{
    "0": {
        "name": "Heartbeat",
        "abbrName": "Heartbeat",
        "added": "FIX.2.7",
        "category": { "section": "Session", "componentType": "Message", "FIXMLFileName": "session", "name": "Session" },
        "msgType": "0",
        "id": "1",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "0",
            "name": "Session",
            "FIXMLFileName": "session",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The Heartbeat monitors the status of the communication link and identifies when the last of a string of messages was not received."
    },
    "1": {
        "name": "TestRequest",
        "abbrName": "TestRequest",
        "added": "FIX.2.7",
        "category": { "section": "Session", "componentType": "Message", "FIXMLFileName": "session", "name": "Session" },
        "msgType": "1",
        "id": "2",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.0",
                "id": "112",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestReqID",
                    "abbrName": "TestReqID",
                    "added": "FIX.3.0",
                    "id": "112",
                    "description": "Identifier included in Test Request message to be returned in resulting Heartbeat"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "0",
            "name": "Session",
            "FIXMLFileName": "session",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The test request message forces a heartbeat from the opposing application. The test request message checks sequence numbers or verifies communication line status. The opposite application responds to the Test Request with a Heartbeat containing the TestReqID."
    },
    "2": {
        "name": "ResendRequest",
        "abbrName": "ResendRequest",
        "added": "FIX.2.7",
        "category": { "section": "Session", "componentType": "Message", "FIXMLFileName": "session", "name": "Session" },
        "msgType": "2",
        "id": "3",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "7",
                "presence": "required",
                "data": {
                    "type": "SeqNum",
                    "name": "BeginSeqNo",
                    "abbrName": "BeginSeqNo",
                    "added": "FIX.2.7",
                    "id": "7",
                    "description": "Message sequence number of first message in range to be resent"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "16",
                "presence": "required",
                "data": {
                    "type": "SeqNum",
                    "name": "EndSeqNo",
                    "abbrName": "EndSeqNo",
                    "added": "FIX.2.7",
                    "id": "16",
                    "description": "Message sequence number of last message in range to be resent. If request is for a single message BeginSeqNo (7) = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = \"0\" (representing infinity)."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "0",
            "name": "Session",
            "FIXMLFileName": "session",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The resend request is sent by the receiving application to initiate the retransmission of messages. This function is utilized if a sequence number gap is detected, if the receiving application lost a message, or as a function of the initialization process."
    },
    "3": {
        "name": "Reject",
        "abbrName": "Reject",
        "added": "FIX.2.7",
        "category": { "section": "Session", "componentType": "Message", "FIXMLFileName": "session", "name": "Session" },
        "msgType": "3",
        "id": "4",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "45",
                "presence": "required",
                "data": {
                    "type": "SeqNum",
                    "name": "RefSeqNum",
                    "abbrName": "RefSeqNum",
                    "added": "FIX.2.7",
                    "id": "45",
                    "description": "Reference message sequence number"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "0",
            "name": "Session",
            "FIXMLFileName": "session",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The reject message should be issued when a message is received but cannot be properly processed due to a session-level rule violation. An example of when a reject may be appropriate would be the receipt of a message with invalid basic data which successfully passes de-encryption, CheckSum and BodyLength checks."
    },
    "4": {
        "name": "SequenceReset",
        "abbrName": "SequenceReset",
        "added": "FIX.2.7",
        "category": { "section": "Session", "componentType": "Message", "FIXMLFileName": "session", "name": "Session" },
        "msgType": "4",
        "id": "5",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "36",
                "presence": "required",
                "data": {
                    "type": "SeqNum",
                    "name": "NewSeqNo",
                    "abbrName": "NewSeqNo",
                    "added": "FIX.2.7",
                    "id": "36",
                    "description": "New sequence number"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "0",
            "name": "Session",
            "FIXMLFileName": "session",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The sequence reset message is used by the sending application to reset the incoming sequence number on the opposing side."
    },
    "5": {
        "name": "Logout",
        "abbrName": "Logout",
        "added": "FIX.2.7",
        "category": { "section": "Session", "componentType": "Message", "FIXMLFileName": "session", "name": "Session" },
        "msgType": "5",
        "id": "6",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "0",
            "name": "Session",
            "FIXMLFileName": "session",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The logout message initiates or confirms the termination of a FIX session. Disconnection without the exchange of logout messages should be interpreted as an abnormal condition."
    },
    "6": {
        "name": "IOI",
        "abbrName": "IOI",
        "added": "FIX.2.7",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "indications",
            "name": "Indication"
        },
        "msgType": "6",
        "id": "7",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "23",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "Indication",
                    "name": "IOIID",
                    "abbrName": "IOIID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "23",
                    "description": "Unique identifier of IOI message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "27",
                "presence": "required",
                "data": {
                    "type": "IOIQtyCodeSet",
                    "name": "IOIQty",
                    "abbrName": "Qty",
                    "unionDataType": "Qty",
                    "added": "FIX.2.7",
                    "id": "27",
                    "description": "Quantity (e.g. number of shares) in numeric form or relative size."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "28",
                "presence": "required",
                "data": {
                    "type": "IOITransTypeCodeSet",
                    "name": "IOITransType",
                    "abbrName": "TransTyp",
                    "added": "FIX.2.7",
                    "id": "28",
                    "description": "Identifies IOI message transaction type"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Indication of interest messages are used to market merchandise which the broker is buying or selling in either a proprietary or agency capacity. The indications can be time bound with a specific expiration value. Indications are distributed with the understanding that other firms may react to the message first and that the merchandise may no longer be available due to prior trade.\n\nIndication messages can be transmitted in various transaction types; NEW, CANCEL, and REPLACE. All message types other than NEW modify the state of the message identified in IOIRefID."
    },
    "7": {
        "name": "Advertisement",
        "abbrName": "Adv",
        "added": "FIX.2.7",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "indications",
            "name": "Indication"
        },
        "msgType": "7",
        "id": "8",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AdvId",
                    "abbrName": "AdvId",
                    "added": "FIX.2.7",
                    "id": "2",
                    "description": "Unique identifier of advertisement message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "4",
                "presence": "required",
                "data": {
                    "type": "AdvSideCodeSet",
                    "name": "AdvSide",
                    "abbrName": "AdvSide",
                    "added": "FIX.2.7",
                    "id": "4",
                    "description": "Broker's side of advertised trade"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "5",
                "presence": "required",
                "data": {
                    "type": "AdvTransTypeCodeSet",
                    "name": "AdvTransType",
                    "abbrName": "AdvTransTyp",
                    "added": "FIX.2.7",
                    "id": "5",
                    "description": "Identifies advertisement message transaction type"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "53",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "name": "Quantity",
                    "abbrName": "Qty",
                    "added": "FIX.2.7",
                    "id": "53",
                    "description": "Overall/total quantity (e.g. number of shares)\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Advertisement messages are used to announce completed transactions. The advertisement message can be transmitted in various transaction types; NEW, CANCEL and REPLACE. All message types other than NEW modify the state of a previously transmitted advertisement identified in AdvRefID."
    },
    "8": {
        "name": "ExecutionReport",
        "abbrName": "ExecRpt",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "order",
            "name": "SingleGeneralOrderHandling"
        },
        "msgType": "8",
        "id": "9",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "14",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "name": "CumQty",
                    "abbrName": "CumQty",
                    "added": "FIX.2.7",
                    "id": "14",
                    "description": "Total quantity (e.g. number of shares) filled.\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.2.7",
                "updatedEP": "188",
                "id": "17",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ExecID",
                    "abbrName": "ExecID",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "95",
                    "id": "17",
                    "description": "Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\n\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n\n(Prior to FIX 4.1 this field was of type int)."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "37",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "OrderID",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "39",
                "presence": "required",
                "data": {
                    "type": "OrdStatusCodeSet",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "OrdStatus",
                    "abbrName": "OrdStat",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Stat",
                    "id": "39",
                    "description": "Identifies current status of order. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.1",
                "id": "150",
                "presence": "required",
                "data": {
                    "type": "ExecTypeCodeSet",
                    "name": "ExecType",
                    "abbrName": "ExecTyp",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.1",
                    "updatedEP": "131",
                    "id": "150",
                    "description": "Describes the specific ExecutionRpt (e.g. Pending Cancel) while OrdStatus(39) will always identify the current order status (e.g. Partially Filled)."
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.1",
                "updatedEP": "188",
                "id": "151",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "name": "LeavesQty",
                    "abbrName": "LeavesQty",
                    "added": "FIX.4.1",
                    "id": "151",
                    "description": "Quantity open for further execution. If the OrdStatus (39) is Canceled, DoneForTheDay, Expired, Calculated, or Rejected (in which case the order is no longer active) then LeavesQty could be 0, otherwise LeavesQty = OrderQty (38) - CumQty (14).\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "188",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The execution report message is used to:\n\n1. confirm the receipt of an order\n\n2. confirm changes to an existing order (i.e. accept cancel and replace requests)\n\n3. relay order status information\n\n4. relay fill information on working orders\n\n5. relay fill information on tradeable or restricted tradeable quotes\n\n6. reject orders\n\n7. report post-trade fees calculations associated with a trade"
    },
    "9": {
        "name": "OrderCancelReject",
        "abbrName": "OrdCxlRej",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "order",
            "name": "SingleGeneralOrderHandling"
        },
        "msgType": "9",
        "id": "10",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "11",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "ClOrdID",
                    "abbrName": "ClOrdID",
                    "updated": "FIX.Latest",
                    "added": "FIX.2.7",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "ID",
                    "id": "11",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "37",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "OrderID",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.4.1",
                "id": "39",
                "presence": "required",
                "data": {
                    "type": "OrdStatusCodeSet",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "OrdStatus",
                    "abbrName": "OrdStat",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Stat",
                    "id": "39",
                    "description": "Identifies current status of order. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "434",
                "presence": "required",
                "data": {
                    "type": "CxlRejResponseToCodeSet",
                    "name": "CxlRejResponseTo",
                    "abbrName": "CxlRejRspTo",
                    "added": "FIX.4.2",
                    "id": "434",
                    "description": "Identifies the type of request that a Cancel Reject is in response to."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The order cancel reject message is issued by the broker upon receipt of a cancel request or cancel/replace request message which cannot be honored."
    },
    "A": {
        "name": "Logon",
        "abbrName": "Logon",
        "added": "FIX.2.7",
        "category": { "section": "Session", "componentType": "Message", "FIXMLFileName": "session", "name": "Session" },
        "msgType": "A",
        "id": "11",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "98",
                "presence": "required",
                "data": {
                    "type": "EncryptMethodCodeSet",
                    "name": "EncryptMethod",
                    "abbrName": "EncryptMethod",
                    "added": "FIX.2.7",
                    "id": "98",
                    "description": "Method of encryption."
                }
            },
            {
                "added": "FIX.3.0",
                "id": "108",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "HeartBtInt",
                    "abbrName": "HeartBtInt",
                    "added": "FIX.3.0",
                    "id": "108",
                    "description": "Heartbeat interval (seconds)"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1137",
                "presence": "required",
                "data": {
                    "type": "ApplVerIDCodeSet",
                    "name": "DefaultApplVerID",
                    "abbrName": "DefApplVerID",
                    "addedEP": "16",
                    "added": "FIX.4.4",
                    "id": "1137",
                    "description": "Specifies the service pack release being applied, by default, to message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "0",
            "name": "Session",
            "FIXMLFileName": "session",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The logon message authenticates a user establishing a connection to a remote system. The logon message must be the first message sent by the application requesting to initiate a FIX session."
    },
    "B": {
        "name": "News",
        "abbrName": "News",
        "added": "FIX.2.7",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "newsevents",
            "name": "EventCommunication"
        },
        "msgType": "B",
        "id": "12",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.1",
                "id": "148",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "Headline",
                    "abbrName": "Headline",
                    "added": "FIX.4.1",
                    "id": "148",
                    "description": "The headline of a News message"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2029",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "LinesOfTextGrp",
                    "abbrName": "TxtLn",
                    "added": "FIX.4.4",
                    "category": "Common",
                    "id": "2029",
                    "numInGroup": { "id": "33", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "58",
                            "presence": "required",
                            "description": "Repeating field, number of instances defined in LinesOfText",
                            "name": "Text"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The news message is a general free format message between the broker and institution. The message contains flags to identify the news item's urgency and to allow sorting by subject company (symbol). The News message can be originated at either the broker or institution side, or exchanges and other marketplace venues."
    },
    "C": {
        "name": "Email",
        "abbrName": "Email",
        "added": "FIX.2.7",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "newsevents",
            "name": "EventCommunication"
        },
        "msgType": "C",
        "id": "13",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "94",
                "presence": "required",
                "data": {
                    "type": "EmailTypeCodeSet",
                    "name": "EmailType",
                    "abbrName": "EmailTyp",
                    "added": "FIX.2.7",
                    "id": "94",
                    "description": "Email message type."
                }
            },
            {
                "added": "FIX.4.1",
                "id": "147",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "Subject",
                    "abbrName": "Subject",
                    "added": "FIX.4.1",
                    "id": "147",
                    "description": "The subject of an Email message"
                }
            },
            {
                "added": "FIX.4.1",
                "id": "164",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "EmailThreadID",
                    "abbrName": "EmailThreadID",
                    "added": "FIX.4.1",
                    "id": "164",
                    "description": "Unique identifier for an email thread (new and chain of replies)"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2029",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "LinesOfTextGrp",
                    "abbrName": "TxtLn",
                    "added": "FIX.4.4",
                    "category": "Common",
                    "id": "2029",
                    "numInGroup": { "id": "33", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "58",
                            "presence": "required",
                            "description": "Repeating field, number of instances defined in LinesOfText",
                            "name": "Text"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The email message is similar to the format and purpose of the News message, however, it is intended for private use between two parties."
    },
    "D": {
        "name": "NewOrderSingle",
        "abbrName": "Order",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "order",
            "name": "SingleGeneralOrderHandling"
        },
        "msgType": "D",
        "id": "14",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "11",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "ClOrdID",
                    "abbrName": "ClOrdID",
                    "updated": "FIX.Latest",
                    "added": "FIX.2.7",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "ID",
                    "id": "11",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "40",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "OrdType",
                    "abbrName": "OrdTyp",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Typ",
                    "id": "40",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "221",
                "id": "1011",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "OrderQtyData",
                    "abbrName": "OrdQty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1011",
                    "description": "The OrderQtyData component block contains the fields commonly used for indicating the amount or quantity of an order. Note that when this component block is marked as \"required\" in a message either one of these three fields must be used to identify the amount: OrderQty, CashOrderQty or OrderPercent (in the case of CIV).\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The new order message type is used by institutions wishing to electronically submit securities and forex orders to a broker for execution.\n\nThe New Order message type may also be used by institutions or retail intermediaries wishing to electronically submit Collective Investment Vehicle (CIV) orders to a broker or fund manager for execution."
    },
    "E": {
        "name": "NewOrderList",
        "abbrName": "NewOrdList",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "listorders",
            "name": "ProgramTrading"
        },
        "msgType": "E",
        "id": "15",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "66",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "ProgramTrading",
                    "name": "ListID",
                    "abbrName": "ListID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "66",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "68",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "TotNoOrders",
                    "abbrName": "TotNoOrds",
                    "added": "FIX.2.7",
                    "id": "68",
                    "description": "Total number of list order entries across all messages. Should be the sum of all NoOrders (73) in each message that has repeating list order entries related to the same ListID (66). Used to support fragmentation.\n\n(Prior to FIX 4.2 this field was named \"ListNoOrds\")"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "394",
                "presence": "required",
                "data": {
                    "type": "BidTypeCodeSet",
                    "name": "BidType",
                    "abbrName": "BidTyp",
                    "added": "FIX.4.2",
                    "id": "394",
                    "description": "Code to identify the type of Bid Request."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2030",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "ListOrdGrp",
                    "abbrName": "Ord",
                    "added": "FIX.4.4",
                    "category": "ProgramTrading",
                    "id": "2030",
                    "numInGroup": { "id": "73", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "11",
                            "presence": "required",
                            "description": "Must be the first field in the repeating group.",
                            "name": "ClOrdID"
                        },
                        {
                            "added": "FIX.4.4",
                            "id": "67",
                            "presence": "required",
                            "description": "Order number within the list",
                            "name": "ListSeqNo"
                        },
                        {
                            "added": "FIX.4.4",
                            "id": "54",
                            "presence": "required",
                            "description": "Note: to indicate the side of SideValue1 or SideValue2, specify Side=Undisclosed and SideValueInd=either the SideValue1 or SideValue2 indicator.",
                            "name": "Side"
                        }
                    ],
                    "componentRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "1003",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        },
                        {
                            "added": "FIX.4.4",
                            "id": "1011",
                            "presence": "required",
                            "description": "Insert here the set of \"OrderQtyData\" fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The NewOrderList Message can be used in one of two ways depending on which market conventions are being followed."
    },
    "F": {
        "name": "OrderCancelRequest",
        "abbrName": "OrdCxlReq",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "order",
            "name": "SingleGeneralOrderHandling"
        },
        "msgType": "F",
        "id": "16",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "11",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "ClOrdID",
                    "abbrName": "ClOrdID",
                    "updated": "FIX.Latest",
                    "added": "FIX.2.7",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "ID",
                    "id": "11",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The order cancel request message requests the cancellation of all of the remaining quantity of an existing order. Note that the Order Cancel/Replace Request should be used to partially cancel (reduce) an order)."
    },
    "G": {
        "name": "OrderCancelReplaceRequest",
        "abbrName": "OrdCxlRplcReq",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "order",
            "name": "SingleGeneralOrderHandling"
        },
        "msgType": "G",
        "id": "17",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.Latest",
                "added": "FIX.2.7",
                "updatedEP": "282",
                "id": "11",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "ClOrdID",
                    "abbrName": "ClOrdID",
                    "updated": "FIX.Latest",
                    "added": "FIX.2.7",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "ID",
                    "id": "11",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "40",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "OrdType",
                    "abbrName": "OrdTyp",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Typ",
                    "id": "40",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "221",
                "id": "1011",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "OrderQtyData",
                    "abbrName": "OrdQty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1011",
                    "description": "The OrderQtyData component block contains the fields commonly used for indicating the amount or quantity of an order. Note that when this component block is marked as \"required\" in a message either one of these three fields must be used to identify the amount: OrderQty, CashOrderQty or OrderPercent (in the case of CIV).\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The order cancel/replace request is used to change the parameters of an existing order.\n\nDo not use this message to cancel the remaining quantity of an outstanding order, use the Order Cancel Request message for this purpose."
    },
    "H": {
        "name": "OrderStatusRequest",
        "abbrName": "OrdStatReq",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "order",
            "name": "SingleGeneralOrderHandling"
        },
        "msgType": "H",
        "id": "18",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The order status request message is used by the institution to generate an order status message back from the broker."
    },
    "J": {
        "name": "AllocationInstruction",
        "abbrName": "AllocInstrctn",
        "updated": "FIX.Latest",
        "added": "FIX.2.7",
        "updatedEP": "291",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "allocation",
            "name": "Allocation"
        },
        "msgType": "J",
        "id": "19",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "53",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "name": "Quantity",
                    "abbrName": "Qty",
                    "added": "FIX.2.7",
                    "id": "53",
                    "description": "Overall/total quantity (e.g. number of shares)\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "70",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "Allocation",
                    "name": "AllocID",
                    "abbrName": "AllocID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "70",
                    "description": "Unique identifier for allocation message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "updated": "FIX.Latest",
                "added": "FIX.2.7",
                "updatedEP": "285",
                "id": "71",
                "presence": "required",
                "data": {
                    "type": "AllocTransTypeCodeSet",
                    "name": "AllocTransType",
                    "abbrName": "TransTyp",
                    "added": "FIX.2.7",
                    "id": "71",
                    "description": "Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "75",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "TradeDate",
                    "abbrName": "TrdDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.2.7",
                    "updatedEP": "190",
                    "id": "75",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "626",
                "presence": "required",
                "data": {
                    "type": "AllocTypeCodeSet",
                    "baseCategory": "Allocation",
                    "name": "AllocType",
                    "abbrName": "AllocType",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Typ",
                    "id": "626",
                    "description": "Describes the specific type or purpose of an Allocation message (i.e. \"Buyside Calculated\")\n\n(see Volume : \"Glossary\" for value definitions)\n\n*** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP1",
                "added": "FIX.4.3",
                "updatedEP": "82",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The AllocationInstruction(35=J) message provides the ability to specify how an order or set of orders should be subdivided amongst one or more accounts.\n\nIn versions of FIX prior to version 4.4, this same message was known as the Allocation(35=J) message. Note in versions of the FIX Protocol prior to version 4.4, the Allocation(35=J) message was also used to communicate fee and expense details from the sell-side to the buy-side. This role has since been removed from the AllocationInstruction(35=J) message and is performed by the new (to version 4.4) AllocationReport(35=AS) and Confirmation(35=AK) messages. The AllocationReport(35=AS) message should be used for the sell-side initiated allocation role as defined in previous versions of the FIX Protocol."
    },
    "K": {
        "name": "ListCancelRequest",
        "abbrName": "ListCxlReq",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "listorders",
            "name": "ProgramTrading"
        },
        "msgType": "K",
        "id": "20",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "66",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "ProgramTrading",
                    "name": "ListID",
                    "abbrName": "ListID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "66",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The List Cancel Request message type is used by institutions wishing to cancel previously submitted lists either before or during execution."
    },
    "L": {
        "name": "ListExecute",
        "abbrName": "ListExct",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "listorders",
            "name": "ProgramTrading"
        },
        "msgType": "L",
        "id": "21",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "66",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "ProgramTrading",
                    "name": "ListID",
                    "abbrName": "ListID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "66",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The List Execute message type is used by institutions to instruct the broker to begin execution of a previously submitted list. This message may or may not be used, as it may be mirroring a phone conversation."
    },
    "M": {
        "name": "ListStatusRequest",
        "abbrName": "ListStatReq",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "listorders",
            "name": "ProgramTrading"
        },
        "msgType": "M",
        "id": "22",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "66",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "ProgramTrading",
                    "name": "ListID",
                    "abbrName": "ListID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "66",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The list status request message type is used by institutions to instruct the broker to generate status messages for a list."
    },
    "N": {
        "name": "ListStatus",
        "abbrName": "ListStat",
        "added": "FIX.2.7",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "listorders",
            "name": "ProgramTrading"
        },
        "msgType": "N",
        "id": "23",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "66",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "ProgramTrading",
                    "name": "ListID",
                    "abbrName": "ListID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "66",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "68",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "TotNoOrders",
                    "abbrName": "TotNoOrds",
                    "added": "FIX.2.7",
                    "id": "68",
                    "description": "Total number of list order entries across all messages. Should be the sum of all NoOrders (73) in each message that has repeating list order entries related to the same ListID (66). Used to support fragmentation.\n\n(Prior to FIX 4.2 this field was named \"ListNoOrds\")"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "82",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "NoRpts",
                    "abbrName": "NoRpts",
                    "added": "FIX.2.7",
                    "id": "82",
                    "description": "Total number of reports within series."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "83",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "RptSeq",
                    "abbrName": "RptSeq",
                    "added": "FIX.2.7",
                    "id": "83",
                    "description": "Sequence number of message within report series. Used to carry reporting sequence number of the fill as represented on the Trade Report Side."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "429",
                "presence": "required",
                "data": {
                    "type": "ListStatusTypeCodeSet",
                    "name": "ListStatusType",
                    "abbrName": "ListStatTyp",
                    "added": "FIX.4.2",
                    "id": "429",
                    "description": "Code to represent the status type."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "431",
                "presence": "required",
                "data": {
                    "type": "ListOrderStatusCodeSet",
                    "name": "ListOrderStatus",
                    "abbrName": "ListOrdStat",
                    "added": "FIX.4.2",
                    "id": "431",
                    "description": "Code to represent the status of a list order."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2037",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "OrdListStatGrp",
                    "abbrName": "ListStat",
                    "added": "FIX.4.4",
                    "category": "ProgramTrading",
                    "id": "2037",
                    "numInGroup": { "id": "73", "added": "FIX.4.4" },
                    "fieldRef": [
                        { "added": "FIX.4.4", "id": "14", "presence": "required", "description": "", "name": "CumQty" },
                        {
                            "added": "FIX.4.4",
                            "id": "39",
                            "presence": "required",
                            "description": "",
                            "name": "OrdStatus"
                        },
                        {
                            "added": "FIX.4.4",
                            "id": "151",
                            "presence": "required",
                            "description": "Quantity open for further execution. LeavesQty = OrderQty - CumQty.",
                            "name": "LeavesQty"
                        },
                        { "added": "FIX.4.4", "id": "84", "presence": "required", "description": "", "name": "CxlQty" },
                        { "added": "FIX.4.4", "id": "6", "presence": "required", "description": "", "name": "AvgPx" }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The list status message is issued as the response to a List Status Request message sent in an unsolicited fashion by the sell-side. It indicates the current state of the orders within the list as they exist at the broker's site. This message may also be used to respond to the List Cancel Request."
    },
    "P": {
        "name": "AllocationInstructionAck",
        "abbrName": "AllocInstrctnAck",
        "added": "FIX.2.7",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "allocation",
            "name": "Allocation"
        },
        "msgType": "P",
        "id": "24",
        "structure": [
            {
                "added": "FIX.2.7",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "70",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "Allocation",
                    "name": "AllocID",
                    "abbrName": "AllocID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "70",
                    "description": "Unique identifier for allocation message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "added": "FIX.2.7",
                "id": "87",
                "presence": "required",
                "data": {
                    "type": "AllocStatusCodeSet",
                    "baseCategory": "Allocation",
                    "name": "AllocStatus",
                    "abbrName": "Stat",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Stat",
                    "id": "87",
                    "description": "Identifies status of allocation."
                }
            },
            {
                "added": "FIX.2.7",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "In versions of FIX prior to version 4.4, this message was known as the Allocation ACK message.\n\nThe Allocation Instruction Ack message is used to acknowledge the receipt of and provide status for an Allocation Instruction message."
    },
    "Q": {
        "name": "DontKnowTrade",
        "abbrName": "DkTrd",
        "added": "FIX.4.0",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "order",
            "name": "SingleGeneralOrderHandling"
        },
        "msgType": "Q",
        "id": "25",
        "structure": [
            {
                "added": "FIX.4.0",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.0",
                "id": "17",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ExecID",
                    "abbrName": "ExecID",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "95",
                    "id": "17",
                    "description": "Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\n\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n\n(Prior to FIX 4.1 this field was of type int)."
                }
            },
            {
                "added": "FIX.4.0",
                "id": "37",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "OrderID",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.4.0",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.0",
                "id": "127",
                "presence": "required",
                "data": {
                    "type": "DKReasonCodeSet",
                    "name": "DKReason",
                    "abbrName": "DkRsn",
                    "added": "FIX.4.0",
                    "id": "127",
                    "description": "Reason for execution rejection."
                }
            },
            {
                "added": "FIX.4.0",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1011",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "OrderQtyData",
                    "abbrName": "OrdQty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1011",
                    "description": "The OrderQtyData component block contains the fields commonly used for indicating the amount or quantity of an order. Note that when this component block is marked as \"required\" in a message either one of these three fields must be used to identify the amount: OrderQty, CashOrderQty or OrderPercent (in the case of CIV).\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The Don’t Know Trade (DK) message notifies a trading partner that an electronically received execution has been rejected. This message can be thought of as an execution reject message."
    },
    "R": {
        "name": "QuoteRequest",
        "abbrName": "QuotReq",
        "added": "FIX.4.0",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "R",
        "id": "26",
        "structure": [
            {
                "added": "FIX.4.0",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.0",
                "id": "131",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "QuoteReqID",
                    "abbrName": "ReqID",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.0",
                    "updatedEP": "143",
                    "id": "131",
                    "description": "Unique identifier for a QuoteRequest(35=R)."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2045",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "QuotReqGrp",
                    "abbrName": "QuotReq",
                    "added": "FIX.4.4",
                    "category": "QuotationNegotiation",
                    "id": "2045",
                    "numInGroup": { "id": "146", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "1003",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.0",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "In some markets it is the practice to request quotes from brokers prior to placement of an order. The quote request message is used for this purpose. This message is commonly referred to as an Request For Quote (RFQ)"
    },
    "S": {
        "name": "Quote",
        "abbrName": "Quot",
        "added": "FIX.4.0",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "S",
        "id": "27",
        "structure": [
            {
                "added": "FIX.4.0",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.0",
                "id": "117",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "QuoteID",
                    "abbrName": "QID",
                    "added": "FIX.4.0",
                    "id": "117",
                    "description": "Unique identifier for quote"
                }
            },
            {
                "added": "FIX.4.0",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "144",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Quote message is used as the response to a Quote Request or a Quote Response message in both indicative, tradeable, and restricted tradeable quoting markets."
    },
    "T": {
        "name": "SettlementInstructions",
        "abbrName": "SettlInstrctns",
        "added": "FIX.4.1",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "settlement",
            "name": "SettlementInstruction"
        },
        "msgType": "T",
        "id": "28",
        "structure": [
            {
                "added": "FIX.4.1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.1",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.1",
                "id": "160",
                "presence": "required",
                "data": {
                    "type": "SettlInstModeCodeSet",
                    "name": "SettlInstMode",
                    "abbrName": "SettlInstMode",
                    "added": "FIX.4.1",
                    "id": "160",
                    "description": "Indicates mode used for Settlement Instructions message. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "777",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SettlInstMsgID",
                    "abbrName": "SettlInstMsgID",
                    "added": "FIX.4.4",
                    "id": "777",
                    "description": "Unique identifier for Settlement Instruction message."
                }
            },
            {
                "added": "FIX.4.1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Settlement Instructions message provides the broker’s, the institution’s, or the intermediary’s instructions for trade settlement. This message has been designed so that it can be sent from the broker to the institution, from the institution to the broker, or from either to an independent \"standing instructions\" database or matching system or, for CIV, from an intermediary to a fund manager."
    },
    "V": {
        "name": "MarketDataRequest",
        "abbrName": "MktDataReq",
        "updated": "FIX.5.0SP2",
        "added": "FIX.4.2",
        "updatedEP": "190",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "V",
        "id": "29",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.2",
                "updatedEP": "190",
                "id": "262",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MDReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "262",
                    "description": "Unique identifier for Market Data Request"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.2",
                "updatedEP": "190",
                "id": "263",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "name": "SubscriptionRequestType",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "264",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "MarketDepth",
                    "abbrName": "MktDepth",
                    "added": "FIX.4.2",
                    "id": "264",
                    "description": "Depth of market for Book Snapshot / Incremental updates\n\n0 - full book depth\n\n1 - top of book\n\n2 and above - book depth (number of levels)"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.4",
                "updatedEP": "190",
                "id": "2022",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "InstrmtMDReqGrp",
                    "abbrName": "InstReq",
                    "added": "FIX.4.4",
                    "category": "Common",
                    "id": "2022",
                    "numInGroup": { "id": "146", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "1003",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.4",
                "updatedEP": "190",
                "id": "2033",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "MDReqGrp",
                    "abbrName": "Req",
                    "added": "FIX.4.4",
                    "category": "MarketData",
                    "id": "2033",
                    "numInGroup": { "id": "267", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "269",
                            "presence": "required",
                            "description": "Must be the first field in this repeating group. This is a list of all the types of Market Data Entries that the firm requesting the Market Data is interested in receiving.",
                            "name": "MDEntryType"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Some systems allow the transmission of real-time quote, order, trade, trade volume, open interest, and/or other price information on a subscription basis. A MarketDataRequest(35=V) is a general request for market data on specific securities or forex quotes. The values in the fields provided within the request will serve as further filter criteria for the result set."
    },
    "W": {
        "name": "MarketDataSnapshotFullRefresh",
        "abbrName": "MktDataFull",
        "added": "FIX.4.2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "W",
        "id": "30",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "190",
                "id": "779",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "LastUpdateTime",
                    "abbrName": "LastUpdateTm",
                    "added": "FIX.4.4",
                    "id": "779",
                    "description": "Timestamp of last update to data item (or creation if no updates made since creation)."
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.4",
                "updatedEP": "190",
                "id": "2031",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "MDFullGrp",
                    "abbrName": "Full",
                    "added": "FIX.4.4",
                    "category": "MarketData",
                    "id": "2031",
                    "numInGroup": { "id": "268", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "updated": "FIX.5.0SP2",
                            "added": "FIX.4.4",
                            "updatedEP": "190",
                            "id": "269",
                            "presence": "required",
                            "description": "Required if NoMDEntries(268) > 0.",
                            "name": "MDEntryType"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "190",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Market Data messages are used as the response to a Market Data Request message. In all cases, one Market Data message refers only to one Market Data Request. It can be used to transmit a 2-sided book of orders or list of quotes, a list of trades, index values, opening, closing, settlement, high, low, or VWAP prices, the trade volume or open interest for a security, or any combination of these."
    },
    "X": {
        "name": "MarketDataIncrementalRefresh",
        "abbrName": "MktDataInc",
        "added": "FIX.4.2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "X",
        "id": "31",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2032",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "MDIncGrp",
                    "abbrName": "Inc",
                    "added": "FIX.4.4",
                    "category": "MarketData",
                    "id": "2032",
                    "numInGroup": { "id": "268", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "updated": "FIX.Latest",
                            "added": "FIX.4.4",
                            "updatedEP": "289",
                            "id": "279",
                            "presence": "required",
                            "description": "Required if NoMDEntries(268) > 0.",
                            "name": "MDUpdateAction"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Market Data message for incremental updates may contain any combination of new, changed, or deleted Market Data Entries, for any combination of instruments, with any combination of trades, imbalances, quotes, index values, open, close, settlement, high, low, and VWAP prices, trade volume and open interest so long as the maximum FIX message size is not exceeded. All of these types of Market Data Entries can be changed and deleted."
    },
    "Y": {
        "name": "MarketDataRequestReject",
        "abbrName": "MktDataReqRej",
        "added": "FIX.4.2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "Y",
        "id": "32",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "262",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MDReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "262",
                    "description": "Unique identifier for Market Data Request"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Market Data Request Reject is used when the broker cannot honor the Market Data Request, due to business or technical reasons. Brokers may choose to limit various parameters, such as the size of requests, whether just the top of book or the entire book may be displayed, and whether Full or Incremental updates must be used."
    },
    "Z": {
        "name": "QuoteCancel",
        "abbrName": "QuotCxl",
        "added": "FIX.4.2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "Z",
        "id": "33",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "298",
                "presence": "required",
                "data": {
                    "type": "QuoteCancelTypeCodeSet",
                    "name": "QuoteCancelType",
                    "abbrName": "CxlTyp",
                    "unionDataType": "Reserved100Plus",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.4.2",
                    "updatedEP": "85",
                    "id": "298",
                    "description": "Identifies the type of quote cancel."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Quote Cancel message is used by an originator of quotes to cancel quotes.\n\nThe Quote Cancel message supports cancellation of:\n\n• All quotes\n\n• Quotes for a specific symbol or security ID\n\n• All quotes for a security type\n\n• All quotes for an underlying"
    },
    "a": {
        "name": "QuoteStatusRequest",
        "abbrName": "QuotStatReq",
        "added": "FIX.4.2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "a",
        "id": "34",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The quote status request message is used for the following purposes in markets that employ tradeable or restricted tradeable quotes:\n\n• For the issuer of a quote in a market to query the status of that quote (using the QuoteID to specify the target quote).\n\n• To subscribe and unsubscribe for Quote Status Report messages for one or more securities."
    },
    "b": {
        "name": "MassQuoteAck",
        "abbrName": "MassQuotAck",
        "updated": "FIX.5.0SP2",
        "added": "FIX.4.2",
        "updatedEP": "143",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "b",
        "id": "35",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "297",
                "presence": "required",
                "data": {
                    "type": "QuoteStatusCodeSet",
                    "name": "QuoteStatus",
                    "abbrName": "Stat",
                    "added": "FIX.4.2",
                    "id": "297",
                    "description": "Identifies the status of the quote acknowledgement."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Mass Quote Acknowledgement is used as the application level response to a Mass Quote message."
    },
    "c": {
        "name": "SecurityDefinitionRequest",
        "abbrName": "SecDefReq",
        "updated": "FIX.5.0SP2",
        "added": "FIX.4.2",
        "updatedEP": "195",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "c",
        "id": "36",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "320",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "321",
                "presence": "required",
                "data": {
                    "type": "SecurityRequestTypeCodeSet",
                    "name": "SecurityRequestType",
                    "abbrName": "ReqTyp",
                    "added": "FIX.4.2",
                    "id": "321",
                    "description": "Type of Security Definition Request."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The SecurityDefinitionRequest(35=c) message is used for the following:\n\n1. Request a specific security to be traded with the second party. The requested security can be defined as a multileg security made up of one or more instrument legs.\n\n2. Request a set of individual securities for a single market segment.\n\n3. Request all securities, independent of market segment."
    },
    "d": {
        "name": "SecurityDefinition",
        "abbrName": "SecDef",
        "updated": "FIX.5.0SP2",
        "added": "FIX.4.2",
        "updatedEP": "195",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "d",
        "id": "37",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The SecurityDefinition(35=d) message is used for the following:\n\n1. Accept the security defined in a SecurityDefinition(35=d) message.\n\n2. Accept the security defined in a SecurityDefinition(35=d) message with changes to the definition and/or identity of the security.\n\n3. Reject the security requested in a SecurityDefinition(35=d) message.\n\n4. Respond to a request for securities within a specified market segment.\n\n5. Convey comprehensive security definition for all market segments that the security participates in.\n\n6. Convey the security's trading rules that differ from default rules for the market segment."
    },
    "e": {
        "name": "SecurityStatusRequest",
        "abbrName": "SecStatReq",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.2",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "e",
        "id": "38",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP1",
                "added": "FIX.4.2",
                "updatedEP": "95",
                "id": "263",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "name": "SubscriptionRequestType",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "324",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityStatusReqID",
                    "abbrName": "StatReqID",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.2",
                    "updatedEP": "106",
                    "id": "324",
                    "description": "Unique ID of a Security Status Request or a Security Mass Status Request message."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security Status Request message provides for the ability to request the status of a security. One or more Security Status messages are returned as a result of a Security Status Request message."
    },
    "f": {
        "name": "SecurityStatus",
        "abbrName": "SecStat",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.2",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "f",
        "id": "39",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "195",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security Status message provides for the ability to report changes in status to a security. The Security Status message contains fields to indicate trading status, corporate actions, financial status of the company. The Security Status message is used by one trading entity (for instance an exchange) to report changes in the state of a security."
    },
    "g": {
        "name": "TradingSessionStatusRequest",
        "abbrName": "TrdgSesStatReq",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.2",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "marketstructure",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "msgType": "g",
        "id": "40",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "263",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "name": "SubscriptionRequestType",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "335",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TradSesReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "335",
                    "description": "Unique ID of a Trading Session Status message."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session Status Request is used to request information on the status of a market. With the move to multiple sessions occurring for a given trading party (morning and evening sessions for instance) there is a need to be able to provide information on what product is trading on what market."
    },
    "h": {
        "name": "TradingSessionStatus",
        "abbrName": "TrdgSesStat",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.2",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "marketstructure",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "msgType": "h",
        "id": "41",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.2",
                "updatedEP": "190",
                "id": "336",
                "presence": "required",
                "data": {
                    "type": "TradingSessionIDCodeSet",
                    "name": "TradingSessionID",
                    "abbrName": "SesID",
                    "unionDataType": "Reserved100Plus",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.2",
                    "updatedEP": "190",
                    "id": "336",
                    "description": "Identifier for a trading session.\n\nA trading session spans an extended period of time that can also be expressed informally in terms of the trading day. Usage is determined by market or counterparties.\n\nTo specify good for session where session spans more than one calendar day, use TimeInForce = 0 (Day) in conjunction with TradingSessionID(336).\n\nBilaterally agreed values of data type \"String\" that start with a character can be used for backward compatibility."
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.2",
                "updatedEP": "190",
                "id": "340",
                "presence": "required",
                "data": {
                    "type": "TradSesStatusCodeSet",
                    "name": "TradSesStatus",
                    "abbrName": "Stat",
                    "unionDataType": "Reserved100Plus",
                    "added": "FIX.4.2",
                    "id": "340",
                    "description": "State of the trading session."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session Status provides information on the status of a market. For markets multiple trading sessions on multiple-markets occurring (morning and evening sessions for instance), this message is able to provide information on what products are trading on what market during what trading session."
    },
    "i": {
        "name": "MassQuote",
        "abbrName": "MassQuot",
        "added": "FIX.4.2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "i",
        "id": "42",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "117",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "QuoteID",
                    "abbrName": "QID",
                    "added": "FIX.4.0",
                    "id": "117",
                    "description": "Unique identifier for quote"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2049",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "QuotSetGrp",
                    "abbrName": "QuotSet",
                    "added": "FIX.4.4",
                    "category": "QuotationNegotiation",
                    "id": "2049",
                    "numInGroup": { "id": "296", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "302",
                            "presence": "required",
                            "description": "Sequential number for the Quote Set. For a given QuoteID - assumed to start at 1.\n\nMust be the first field in the repeating group.",
                            "name": "QuoteSetID"
                        },
                        {
                            "added": "FIX.4.4",
                            "id": "304",
                            "presence": "required",
                            "description": "Total number of quotes for the quote set across all messages. Should be the sum of all NoQuoteEntries in each message that has repeating quotes that are part of the same quote set.",
                            "name": "TotNoQuoteEntries"
                        }
                    ],
                    "groupRef": [{ "added": "FIX.4.4", "id": "2043", "presence": "required", "description": "" }],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Mass Quote message can contain quotes for multiple securities to support applications that allow for the mass quoting of an option series. Two levels of repeating groups have been provided to minimize the amount of data required to submit a set of quotes for a class of options (e.g. all option series for IBM)."
    },
    "j": {
        "name": "BusinessMessageReject",
        "abbrName": "BizMsgRej",
        "added": "FIX.4.2",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "businessreject",
            "name": "BusinessReject"
        },
        "msgType": "j",
        "id": "43",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "372",
                "presence": "required",
                "data": {
                    "type": "MsgTypeCodeSet",
                    "name": "RefMsgType",
                    "abbrName": "RefMsgTyp",
                    "added": "FIX.4.2",
                    "id": "372",
                    "description": "The MsgType (35) of the FIX message being referenced."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "380",
                "presence": "required",
                "data": {
                    "type": "BusinessRejectReasonCodeSet",
                    "name": "BusinessRejectReason",
                    "abbrName": "BizRejRsn",
                    "added": "FIX.4.2",
                    "id": "380",
                    "description": "Code to identify reason for a Business Message Reject message."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "The Business Message Reject message can reject an application-level message which fulfills session-level rules and cannot be rejected via any other means. Note if the message fails a session-level rule (e.g. body length is incorrect), a session-level Reject message should be issued."
    },
    "k": {
        "name": "BidRequest",
        "abbrName": "BidReq",
        "added": "FIX.4.2",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "listorders",
            "name": "ProgramTrading"
        },
        "msgType": "k",
        "id": "44",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "374",
                "presence": "required",
                "data": {
                    "type": "BidRequestTransTypeCodeSet",
                    "name": "BidRequestTransType",
                    "abbrName": "BidReqTransTyp",
                    "added": "FIX.4.2",
                    "id": "374",
                    "description": "Identifies the Bid Request message type."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "391",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ClientBidID",
                    "abbrName": "ClBidID",
                    "added": "FIX.4.2",
                    "id": "391",
                    "description": "Unique identifier for a Bid Request as assigned by institution. Uniqueness must be guaranteed within a single trading day."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "393",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "TotNoRelatedSym",
                    "abbrName": "TotNoReltdSym",
                    "added": "FIX.4.2",
                    "id": "393",
                    "description": "Total number of securities.\n\n(Prior to FIX 4.4 this field was named TotalNumSecurities)"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "394",
                "presence": "required",
                "data": {
                    "type": "BidTypeCodeSet",
                    "name": "BidType",
                    "abbrName": "BidTyp",
                    "added": "FIX.4.2",
                    "id": "394",
                    "description": "Code to identify the type of Bid Request."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "418",
                "presence": "required",
                "data": {
                    "type": "BidTradeTypeCodeSet",
                    "name": "BidTradeType",
                    "abbrName": "BidTrdTyp",
                    "added": "FIX.4.2",
                    "id": "418",
                    "description": "Code to represent the type of trade.\n\n(Prior to FIX 4.4 this field was named \"TradeType\")"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "419",
                "presence": "required",
                "data": {
                    "type": "BasisPxTypeCodeSet",
                    "name": "BasisPxType",
                    "abbrName": "BasisPxTyp",
                    "added": "FIX.4.2",
                    "id": "419",
                    "description": "Code to represent the basis price type."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The BidRequest Message can be used in one of two ways depending on which market conventions are being followed.\n\nIn the \"Non disclosed\" convention (e.g. US/European model) the BidRequest message can be used to request a bid based on the sector, country, index and liquidity information contained within the message itself. In the \"Non disclosed\" convention the entry repeating group is used to define liquidity of the program. See \" Program/Basket/List Trading\" for an example.\n\nIn the \"Disclosed\" convention (e.g. Japanese model) the BidRequest message can be used to request bids based on the ListOrderDetail messages sent in advance of BidRequest message. In the \"Disclosed\" convention the list repeating group is used to define which ListOrderDetail messages a bid is being sort for and the directions of the required bids."
    },
    "l": {
        "name": "BidResponse",
        "abbrName": "BidRsp",
        "added": "FIX.4.2",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "listorders",
            "name": "ProgramTrading"
        },
        "msgType": "l",
        "id": "45",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2005",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "BidCompRspGrp",
                    "abbrName": "CompRsp",
                    "added": "FIX.4.4",
                    "category": "ProgramTrading",
                    "id": "2005",
                    "numInGroup": { "id": "420", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "updated": "FIX.5.0SP1",
                            "added": "FIX.4.4",
                            "updatedEP": "95",
                            "id": "1000",
                            "presence": "required",
                            "description": "First element Commission required if NoBidComponents > 0."
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The Bid Response message can be used in one of two ways depending on which market conventions are being followed.\n\nIn the \"Non disclosed\" convention the Bid Response message can be used to supply a bid based on the sector, country, index and liquidity information contained within the corresponding bid request message. See \"Program/Basket/List Trading\" for an example.\n\nIn the \"Disclosed\" convention the Bid Response message can be used to supply bids based on the List Order Detail messages sent in advance of the corresponding Bid Request message."
    },
    "m": {
        "name": "ListStrikePrice",
        "abbrName": "ListStrkPx",
        "added": "FIX.4.2",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "listorders",
            "name": "ProgramTrading"
        },
        "msgType": "m",
        "id": "46",
        "structure": [
            {
                "added": "FIX.4.2",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "66",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "ProgramTrading",
                    "name": "ListID",
                    "abbrName": "ListID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "66",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.4.2",
                "id": "422",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "TotNoStrikes",
                    "abbrName": "TotNoStrks",
                    "added": "FIX.4.2",
                    "id": "422",
                    "description": "Total number of strike price entries across all messages. Should be the sum of all NoStrikes (428) in each message that has repeating strike price entries related to the same ListID (66). Used to support fragmentation."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2023",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "InstrmtStrkPxGrp",
                    "abbrName": "StrkPX",
                    "added": "FIX.4.4",
                    "category": "ProgramTrading",
                    "id": "2023",
                    "numInGroup": { "id": "428", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "1003",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\"\n\nRequired if NoStrikes > 0. Must be first field in repeating group."
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.2",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The strike price message is used to exchange strike price information for principal trades. It can also be used to exchange reference prices for agency trades."
    },
    "n": {
        "name": "XMLnonFIX",
        "abbrName": "XMLnonFIX",
        "added": "FIX.4.3",
        "category": { "section": "Session", "componentType": "Message", "FIXMLFileName": "session", "name": "Session" },
        "msgType": "n",
        "id": "47",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "0",
            "name": "Session",
            "FIXMLFileName": "session",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": ""
    },
    "o": {
        "name": "RegistrationInstructions",
        "abbrName": "RgstInstrctns",
        "added": "FIX.4.3",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "registration",
            "name": "RegistrationInstruction"
        },
        "msgType": "o",
        "id": "48",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "508",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "RegistrationInstruction",
                    "name": "RegistRefID",
                    "abbrName": "RefID",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.3",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "RefID",
                    "id": "508",
                    "description": "Reference identifier for the RegistID(513) with Cancel and Replace RegistTransType(514) transaction types."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "513",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "RegistrationInstruction",
                    "name": "RegistID",
                    "abbrName": "RegistID",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "ID",
                    "id": "513",
                    "description": "Unique identifier of the registration details as assigned by institution or intermediary."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "514",
                "presence": "required",
                "data": {
                    "type": "RegistTransTypeCodeSet",
                    "name": "RegistTransType",
                    "abbrName": "TransTyp",
                    "added": "FIX.4.3",
                    "id": "514",
                    "description": "Identifies Registration Instructions transaction type"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Registration Instructions message type may be used by institutions or retail intermediaries wishing to electronically submit registration information to a broker or fund manager (for CIV) for an order or for an allocation."
    },
    "p": {
        "name": "RegistrationInstructionsResponse",
        "abbrName": "RgstInstrctnsRsp",
        "added": "FIX.4.3",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "registration",
            "name": "RegistrationInstruction"
        },
        "msgType": "p",
        "id": "49",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "506",
                "presence": "required",
                "data": {
                    "type": "RegistStatusCodeSet",
                    "name": "RegistStatus",
                    "abbrName": "RegStat",
                    "added": "FIX.4.3",
                    "id": "506",
                    "description": "Registration status as returned by the broker or (for CIV) the fund manager:"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "508",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "RegistrationInstruction",
                    "name": "RegistRefID",
                    "abbrName": "RefID",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.3",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "RefID",
                    "id": "508",
                    "description": "Reference identifier for the RegistID(513) with Cancel and Replace RegistTransType(514) transaction types."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "513",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "RegistrationInstruction",
                    "name": "RegistID",
                    "abbrName": "RegistID",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "ID",
                    "id": "513",
                    "description": "Unique identifier of the registration details as assigned by institution or intermediary."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "514",
                "presence": "required",
                "data": {
                    "type": "RegistTransTypeCodeSet",
                    "name": "RegistTransType",
                    "abbrName": "TransTyp",
                    "added": "FIX.4.3",
                    "id": "514",
                    "description": "Identifies Registration Instructions transaction type"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Registration Instructions Response message type may be used by broker or fund manager (for CIV) in response to a Registration Instructions message submitted by an institution or retail intermediary for an order or for an allocation."
    },
    "q": {
        "name": "OrderMassCancelRequest",
        "abbrName": "OrdMassCxlReq",
        "added": "FIX.4.3",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "ordermasshandling",
            "name": "OrderMassHandling"
        },
        "msgType": "q",
        "id": "50",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "11",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "ClOrdID",
                    "abbrName": "ClOrdID",
                    "updated": "FIX.Latest",
                    "added": "FIX.2.7",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "ID",
                    "id": "11",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "530",
                "presence": "required",
                "data": {
                    "type": "MassCancelRequestTypeCodeSet",
                    "baseCategory": "OrderMassHandling",
                    "name": "MassCancelRequestType",
                    "abbrName": "MassCxlReqTyp",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "ReqTyp",
                    "id": "530",
                    "description": "Specifies scope of Order Mass Cancel Request."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The order mass cancel request message requests the cancellation of all of the remaining quantity of a group of orders matching criteria specified within the request. NOTE: This message can only be used to cancel order messages (reduce the full quantity)."
    },
    "r": {
        "name": "OrderMassCancelReport",
        "abbrName": "OrdMassCxlRpt",
        "added": "FIX.4.3",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "ordermasshandling",
            "name": "OrderMassHandling"
        },
        "msgType": "r",
        "id": "51",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "deprecated": "FIX.5.0SP1",
                "id": "37",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "OrderID",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "530",
                "presence": "required",
                "data": {
                    "type": "MassCancelRequestTypeCodeSet",
                    "baseCategory": "OrderMassHandling",
                    "name": "MassCancelRequestType",
                    "abbrName": "MassCxlReqTyp",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "ReqTyp",
                    "id": "530",
                    "description": "Specifies scope of Order Mass Cancel Request."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "531",
                "presence": "required",
                "data": {
                    "type": "MassCancelResponseCodeSet",
                    "baseCategory": "OrderMassHandling",
                    "name": "MassCancelResponse",
                    "abbrName": "MassCxlRsp",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Rsp",
                    "id": "531",
                    "description": "Specifies the action taken by counterparty order handling system as a result of the Order Mass Cancel Request"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1369",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MassActionReportID",
                    "abbrName": "MassActionReportID",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "id": "1369",
                    "description": "Unique identifier of Order Mass Cancel Report or Order Mass Action Report message as assigned by sell-side (broker, exchange, ECN)"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The Order Mass Cancel Report is used to acknowledge an Order Mass Cancel Request. Note that each affected order that is canceled is acknowledged with a separate Execution Report or Order Cancel Reject message."
    },
    "s": {
        "name": "NewOrderCross",
        "abbrName": "NewOrdCrss",
        "added": "FIX.4.3",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "crossorders",
            "name": "CrossOrders"
        },
        "msgType": "s",
        "id": "52",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "40",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "OrdType",
                    "abbrName": "OrdTyp",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Typ",
                    "id": "40",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "548",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "CrossOrders",
                    "name": "CrossID",
                    "abbrName": "CrssID",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "ID",
                    "id": "548",
                    "description": "Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "549",
                "presence": "required",
                "data": {
                    "type": "CrossTypeCodeSet",
                    "baseCategory": "CrossOrders",
                    "name": "CrossType",
                    "abbrName": "CrssTyp",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Typ",
                    "id": "549",
                    "description": "Type of cross being submitted to a market"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "550",
                "presence": "required",
                "data": {
                    "type": "CrossPrioritizationCodeSet",
                    "baseCategory": "CrossOrders",
                    "name": "CrossPrioritization",
                    "abbrName": "CrssPriortstn",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Priorty",
                    "id": "550",
                    "description": "Indicates if one side or the other of a cross order should be prioritized.\n\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected)."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2059",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "SideCrossOrdModGrp",
                    "abbrName": "SideCrossMod",
                    "added": "FIX.4.4",
                    "category": "CrossOrders",
                    "id": "2059",
                    "numInGroup": { "id": "552", "added": "FIX.4.4", "updated": "FIX.5.0SP2", "updatedEP": "131" },
                    "fieldRef": [
                        {
                            "updated": "FIX.5.0SP2",
                            "added": "FIX.4.4",
                            "updatedEP": "131",
                            "id": "54",
                            "presence": "required",
                            "description": "Required if NoSides(552) > 0.",
                            "name": "Side"
                        },
                        {
                            "added": "FIX.4.4",
                            "id": "11",
                            "presence": "required",
                            "description": "Unique identifier of the order as assigned by institution or by the intermediary with closest association with the investor.",
                            "name": "ClOrdID"
                        }
                    ],
                    "componentRef": [
                        {
                            "updated": "FIX.5.0SP2",
                            "added": "FIX.4.4",
                            "updatedEP": "131",
                            "id": "1011",
                            "presence": "required",
                            "description": ""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "Used to submit a cross order into a market. The cross order contains two order sides (a buy and a sell). The cross order is identified by its CrossID."
    },
    "t": {
        "name": "CrossOrderCancelReplaceRequest",
        "abbrName": "CrssOrdCxlRplcReq",
        "added": "FIX.4.3",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "crossorders",
            "name": "CrossOrders"
        },
        "msgType": "t",
        "id": "53",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "40",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "OrdType",
                    "abbrName": "OrdTyp",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Typ",
                    "id": "40",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "548",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "CrossOrders",
                    "name": "CrossID",
                    "abbrName": "CrssID",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "ID",
                    "id": "548",
                    "description": "Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "549",
                "presence": "required",
                "data": {
                    "type": "CrossTypeCodeSet",
                    "baseCategory": "CrossOrders",
                    "name": "CrossType",
                    "abbrName": "CrssTyp",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Typ",
                    "id": "549",
                    "description": "Type of cross being submitted to a market"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "550",
                "presence": "required",
                "data": {
                    "type": "CrossPrioritizationCodeSet",
                    "baseCategory": "CrossOrders",
                    "name": "CrossPrioritization",
                    "abbrName": "CrssPriortstn",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Priorty",
                    "id": "550",
                    "description": "Indicates if one side or the other of a cross order should be prioritized.\n\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected)."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "551",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "CrossOrders",
                    "name": "OrigCrossID",
                    "abbrName": "OrigCrssID",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "OrigID",
                    "id": "551",
                    "description": "CrossID of the previous cross order (NOT the initial cross order of the day) as assigned by the institution, used to identify the previous cross order in Cross Cancel and Cross Cancel/Replace Requests."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2059",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "SideCrossOrdModGrp",
                    "abbrName": "SideCrossMod",
                    "added": "FIX.4.4",
                    "category": "CrossOrders",
                    "id": "2059",
                    "numInGroup": { "id": "552", "added": "FIX.4.4", "updated": "FIX.5.0SP2", "updatedEP": "131" },
                    "fieldRef": [
                        {
                            "updated": "FIX.5.0SP2",
                            "added": "FIX.4.4",
                            "updatedEP": "131",
                            "id": "54",
                            "presence": "required",
                            "description": "Required if NoSides(552) > 0.",
                            "name": "Side"
                        },
                        {
                            "added": "FIX.4.4",
                            "id": "11",
                            "presence": "required",
                            "description": "Unique identifier of the order as assigned by institution or by the intermediary with closest association with the investor.",
                            "name": "ClOrdID"
                        }
                    ],
                    "componentRef": [
                        {
                            "updated": "FIX.5.0SP2",
                            "added": "FIX.4.4",
                            "updatedEP": "131",
                            "id": "1011",
                            "presence": "required",
                            "description": ""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "Used to modify a cross order previously submitted using the New Order - Cross message. See Order Cancel Replace Request for details concerning message usage."
    },
    "u": {
        "name": "CrossOrderCancelRequest",
        "abbrName": "CrssOrdCxlReq",
        "added": "FIX.4.3",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "crossorders",
            "name": "CrossOrders"
        },
        "msgType": "u",
        "id": "54",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "548",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "CrossOrders",
                    "name": "CrossID",
                    "abbrName": "CrssID",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "ID",
                    "id": "548",
                    "description": "Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "549",
                "presence": "required",
                "data": {
                    "type": "CrossTypeCodeSet",
                    "baseCategory": "CrossOrders",
                    "name": "CrossType",
                    "abbrName": "CrssTyp",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Typ",
                    "id": "549",
                    "description": "Type of cross being submitted to a market"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "550",
                "presence": "required",
                "data": {
                    "type": "CrossPrioritizationCodeSet",
                    "baseCategory": "CrossOrders",
                    "name": "CrossPrioritization",
                    "abbrName": "CrssPriortstn",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Priorty",
                    "id": "550",
                    "description": "Indicates if one side or the other of a cross order should be prioritized.\n\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected)."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "551",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "CrossOrders",
                    "name": "OrigCrossID",
                    "abbrName": "OrigCrssID",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "OrigID",
                    "id": "551",
                    "description": "CrossID of the previous cross order (NOT the initial cross order of the day) as assigned by the institution, used to identify the previous cross order in Cross Cancel and Cross Cancel/Replace Requests."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2058",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "SideCrossOrdCxlGrp",
                    "abbrName": "SideCrossCxl",
                    "added": "FIX.4.4",
                    "category": "CrossOrders",
                    "id": "2058",
                    "numInGroup": { "id": "552", "added": "FIX.4.4" },
                    "fieldRef": [
                        { "added": "FIX.4.4", "id": "54", "presence": "required", "description": "", "name": "Side" },
                        {
                            "added": "FIX.4.4",
                            "id": "11",
                            "presence": "required",
                            "description": "Unique identifier of the order as assigned by institution or by the intermediary with closest association with the investor.",
                            "name": "ClOrdID"
                        }
                    ],
                    "componentRef": [
                        {
                            "updated": "FIX.5.0SP2",
                            "added": "FIX.4.4",
                            "updatedEP": "221",
                            "id": "1011",
                            "presence": "required",
                            "description": ""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "Used to fully cancel the remaining open quantity of a cross order."
    },
    "v": {
        "name": "SecurityTypeRequest",
        "abbrName": "SecTypReq",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.3",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "v",
        "id": "55",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "320",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security Type Request message is used to return a list of security types available from a counterparty or market."
    },
    "w": {
        "name": "SecurityTypes",
        "abbrName": "SecTyps",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.3",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "w",
        "id": "56",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "320",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "322",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityResponseID",
                    "abbrName": "RspID",
                    "added": "FIX.4.2",
                    "id": "322",
                    "description": "Unique ID of a Security Definition message."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "323",
                "presence": "required",
                "data": {
                    "type": "SecurityResponseTypeCodeSet",
                    "name": "SecurityResponseType",
                    "abbrName": "RspTyp",
                    "added": "FIX.4.2",
                    "id": "323",
                    "description": "Type of Security Definition message response."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security Type Request message is used to return a list of security types available from a counterparty or market."
    },
    "x": {
        "name": "SecurityListRequest",
        "abbrName": "SecListReq",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.3",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "x",
        "id": "57",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "320",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "559",
                "presence": "required",
                "data": {
                    "type": "SecurityListRequestTypeCodeSet",
                    "name": "SecurityListRequestType",
                    "abbrName": "ListReqTyp",
                    "added": "FIX.4.3",
                    "id": "559",
                    "description": "Identifies the type/criteria of Security List Request"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request"
    },
    "y": {
        "name": "SecurityList",
        "abbrName": "SecList",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.3",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "y",
        "id": "58",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security List message is used to return a list of securities that matches the criteria specified in a Security List Request."
    },
    "z": {
        "name": "DerivativeSecurityListRequest",
        "abbrName": "DerivSecListReq",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.3",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "z",
        "id": "59",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "320",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "559",
                "presence": "required",
                "data": {
                    "type": "SecurityListRequestTypeCodeSet",
                    "name": "SecurityListRequestType",
                    "abbrName": "ListReqTyp",
                    "added": "FIX.4.3",
                    "id": "559",
                    "description": "Identifies the type/criteria of Security List Request"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Derivative Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request"
    },
    "AA": {
        "name": "DerivativeSecurityList",
        "abbrName": "DerivSecList",
        "updated": "FIX.5.0SP1",
        "added": "FIX.4.3",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "AA",
        "id": "60",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Derivative Security List message is used to return a list of securities that matches the criteria specified in a Derivative Security List Request."
    },
    "AB": {
        "name": "NewOrderMultileg",
        "abbrName": "NewOrdMleg",
        "added": "FIX.4.3",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "multilegorders",
            "name": "MultilegOrders"
        },
        "msgType": "AB",
        "id": "61",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "11",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "ClOrdID",
                    "abbrName": "ClOrdID",
                    "updated": "FIX.Latest",
                    "added": "FIX.2.7",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "ID",
                    "id": "11",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "40",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "OrdType",
                    "abbrName": "OrdTyp",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Typ",
                    "id": "40",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The New Order - Multileg is provided to submit orders for securities that are made up of multiple securities, known as legs."
    },
    "AC": {
        "name": "MultilegOrderCancelReplace",
        "abbrName": "MlegOrdCxlRplc",
        "added": "FIX.4.3",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "multilegorders",
            "name": "MultilegOrders"
        },
        "msgType": "AC",
        "id": "62",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "40",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "OrdType",
                    "abbrName": "OrdTyp",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Typ",
                    "id": "40",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "Used to modify a multileg order previously submitted using the New Order - Multileg message. See Order Cancel Replace Request for details concerning message usage."
    },
    "AD": {
        "name": "TradeCaptureReportRequest",
        "abbrName": "TrdCaptRptReq",
        "added": "FIX.4.3",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "tradecapture",
            "name": "TradeCapture"
        },
        "msgType": "AD",
        "id": "63",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "141",
                "id": "568",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TradeRequestID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.3",
                    "id": "568",
                    "description": "Trade Capture Report Request ID"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "569",
                "presence": "required",
                "data": {
                    "type": "TradeRequestTypeCodeSet",
                    "name": "TradeRequestType",
                    "abbrName": "ReqTyp",
                    "added": "FIX.4.3",
                    "id": "569",
                    "description": "Type of Trade Capture Report."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Trade Capture Report Request can be used to:\n\n• Request one or more trade capture reports based upon selection criteria provided on the trade capture report request\n\n• Subscribe for trade capture reports based upon selection criteria provided on the trade capture report request."
    },
    "AE": {
        "name": "TradeCaptureReport",
        "abbrName": "TrdCaptRpt",
        "updated": "FIX.5.0SP2",
        "added": "FIX.4.3",
        "updatedEP": "192",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "tradecapture",
            "name": "TradeCapture"
        },
        "msgType": "AE",
        "id": "64",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.4",
                "updatedEP": "141",
                "id": "2061",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "TrdCapRptSideGrp",
                    "abbrName": "RptSide",
                    "added": "FIX.4.4",
                    "category": "TradeCapture",
                    "id": "2061",
                    "numInGroup": { "id": "552", "added": "FIX.4.4", "updated": "FIX.5.0SP2", "updatedEP": "141" },
                    "fieldRef": [
                        {
                            "updated": "FIX.5.0SP2",
                            "added": "FIX.4.4",
                            "updatedEP": "141",
                            "id": "54",
                            "presence": "required",
                            "description": "Required when NoSides(552) > 0.",
                            "name": "Side"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "167",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.3",
                "updatedEP": "141",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Trade Capture Report message can be:\n\n- Used to report trades between counterparties.\n\n- Used to report trades to a trade matching system.\n\n- Sent unsolicited between counterparties.\n\n- Sent as a reply to a Trade Capture Report Request.\n\n- Used to report unmatched and matched trades."
    },
    "AF": {
        "name": "OrderMassStatusRequest",
        "abbrName": "OrdMassStatReq",
        "added": "FIX.4.3",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "ordermasshandling",
            "name": "OrderMassHandling"
        },
        "msgType": "AF",
        "id": "65",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "584",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "OrderMassHandling",
                    "name": "MassStatusReqID",
                    "abbrName": "MassStatReqID",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "ReqID",
                    "id": "584",
                    "description": "Value assigned by issuer of Mass Status Request to uniquely identify the request"
                }
            },
            {
                "updated": "FIX.Latest",
                "added": "FIX.4.3",
                "updatedEP": "271",
                "id": "585",
                "presence": "required",
                "data": {
                    "type": "MassStatusReqTypeCodeSet",
                    "baseCategory": "OrderMassHandling",
                    "name": "MassStatusReqType",
                    "abbrName": "MassStatReqTyp",
                    "unionDataType": "Reserved100Plus",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.3",
                    "updatedEP": "271",
                    "baseCategoryAbbrName": "ReqTyp",
                    "id": "585",
                    "description": "Specifies the type or scope of the mass order status request."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The order mass status request message requests the status for orders matching criteria specified within the request."
    },
    "AG": {
        "name": "QuoteRequestReject",
        "abbrName": "QuotReqRej",
        "added": "FIX.4.3",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "AG",
        "id": "66",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "131",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "QuoteReqID",
                    "abbrName": "ReqID",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.0",
                    "updatedEP": "143",
                    "id": "131",
                    "description": "Unique identifier for a QuoteRequest(35=R)."
                }
            },
            {
                "added": "FIX.4.3",
                "id": "658",
                "presence": "required",
                "data": {
                    "type": "QuoteRequestRejectReasonCodeSet",
                    "name": "QuoteRequestRejectReason",
                    "abbrName": "ReqRejRsn",
                    "unionDataType": "Reserved100Plus",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.3",
                    "updatedEP": "290",
                    "id": "658",
                    "description": "Reason quote request was rejected."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2047",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "QuotReqRjctGrp",
                    "abbrName": "QuotReqRej",
                    "added": "FIX.4.4",
                    "category": "QuotationNegotiation",
                    "id": "2047",
                    "numInGroup": { "id": "146", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "1003",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Quote Request Reject message is used to reject Quote Request messages for all quoting models."
    },
    "AH": {
        "name": "RFQRequest",
        "abbrName": "RFQReq",
        "added": "FIX.4.3",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "AH",
        "id": "67",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "644",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "RFQReqID",
                    "abbrName": "RFQReqID",
                    "added": "FIX.4.3",
                    "id": "644",
                    "description": "RFQ Request ID - used to identify an RFQ Request."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2051",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "RFQReqGrp",
                    "abbrName": "RFQReq",
                    "added": "FIX.4.4",
                    "category": "QuotationNegotiation",
                    "id": "2051",
                    "numInGroup": { "id": "146", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "1003",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "In tradeable and restricted tradeable quoting markets – Quote Requests are issued by counterparties interested in ascertaining the market for an instrument. Quote Requests are then distributed by the market to liquidity providers who make markets in the instrument. The RFQ Request is used by liquidity providers to indicate to the market for which instruments they are interested in receiving Quote Requests. It can be used to register interest in receiving quote requests for a single instrument or for multiple instruments"
    },
    "AI": {
        "name": "QuoteStatusReport",
        "abbrName": "QuotStatRpt",
        "added": "FIX.4.3",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "AI",
        "id": "68",
        "structure": [
            {
                "added": "FIX.4.3",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.3",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The quote status report message is used:\n\n• as the response to a Quote Status Request message\n\n• as a response to a Quote Cancel message\n\n• as a response to a Quote Response message in a negotiation dialog (see Volume 7 – PRODUCT: FIXED INCOME and USER GROUP: EXCHANGES AND MARKETS)"
    },
    "AJ": {
        "name": "QuoteResponse",
        "abbrName": "QuotRsp",
        "updated": "FIX.5.0SP2",
        "added": "FIX.4.4",
        "updatedEP": "143",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "AJ",
        "id": "69",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "693",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "QuoteRespID",
                    "abbrName": "RspID",
                    "added": "FIX.4.4",
                    "id": "693",
                    "description": "Message reference for Quote Response"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.4",
                "updatedEP": "143",
                "id": "694",
                "presence": "required",
                "data": {
                    "type": "QuoteRespTypeCodeSet",
                    "name": "QuoteRespType",
                    "abbrName": "RspTyp",
                    "added": "FIX.4.4",
                    "id": "694",
                    "description": "Identifies the type of Quote Response."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The QuoteResponse(35=AJ) message is used for the following purposes:\n\n1. Respond to an IOI(35=6) message\n\n2. Respond to a Quote(35=S) message\n\n3. Counter a Quote\n\n4. End a negotiation dialog\n\n5. Follow-up or end a QuoteRequest(35=R) dialog that did not receive a response.\n\nFor usage of this message in a negotiation or counter quote dialog for fixed income and exchanges/marketplace see Volume 7, Fixed Income and Exchanges and Markets sections respectively."
    },
    "AK": {
        "name": "Confirmation",
        "abbrName": "Cnfm",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "confirmation",
            "name": "Confirmation"
        },
        "msgType": "AK",
        "id": "70",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "6",
                "presence": "required",
                "data": {
                    "type": "Price",
                    "name": "AvgPx",
                    "abbrName": "AvgPx",
                    "added": "FIX.2.7",
                    "id": "6",
                    "description": "Calculated average price of all fills on this order.\n\nFor Fixed Income trades AvgPx is always expressed as percent-of-par, regardless of the PriceType (423) of LastPx (31). I.e., AvgPx will contain an average of percent-of-par values (see LastParPx (669)) for issues traded in Yield, Spread or Discount."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "75",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "TradeDate",
                    "abbrName": "TrdDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.2.7",
                    "updatedEP": "190",
                    "id": "75",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "79",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AllocAccount",
                    "abbrName": "Acct",
                    "added": "FIX.2.7",
                    "id": "79",
                    "description": "Sub-account mnemonic"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "80",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "name": "AllocQty",
                    "abbrName": "Qty",
                    "added": "FIX.2.7",
                    "id": "80",
                    "description": "Quantity to be allocated to specific sub-account\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "118",
                "presence": "required",
                "data": {
                    "type": "Amt",
                    "name": "NetMoney",
                    "abbrName": "NetMny",
                    "added": "FIX.4.0",
                    "id": "118",
                    "description": "Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution."
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.4",
                "updatedEP": "258",
                "id": "381",
                "presence": "required",
                "data": {
                    "type": "Amt",
                    "name": "GrossTradeAmt",
                    "abbrName": "GrossTrdAmt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.2",
                    "updatedEP": "258",
                    "id": "381",
                    "description": "Total amount traded expressed in units of currency - usually quantity * price. For FX Futures this is used to express the notional value of a fill when quantity fields are expressed in terms of contract size (i.e. quantity * price * contract size)."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "664",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ConfirmID",
                    "abbrName": "CnfmID",
                    "added": "FIX.4.4",
                    "id": "664",
                    "description": "Message reference for Confirmation"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "665",
                "presence": "required",
                "data": {
                    "type": "ConfirmStatusCodeSet",
                    "name": "ConfirmStatus",
                    "abbrName": "CnfmStat",
                    "added": "FIX.4.4",
                    "id": "665",
                    "description": "Identifies the status of the Confirmation."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "666",
                "presence": "required",
                "data": {
                    "type": "ConfirmTransTypeCodeSet",
                    "name": "ConfirmTransType",
                    "abbrName": "CnfmTransTyp",
                    "added": "FIX.4.4",
                    "id": "666",
                    "description": "Identifies the Confirmation transaction type."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "773",
                "presence": "required",
                "data": {
                    "type": "ConfirmTypeCodeSet",
                    "name": "ConfirmType",
                    "abbrName": "CnfmTyp",
                    "added": "FIX.4.4",
                    "id": "773",
                    "description": "Identifies the type of Confirmation message being sent."
                }
            },
            {
                "updated": "FIX.5.0SP1",
                "added": "FIX.4.4",
                "updatedEP": "95",
                "id": "2013",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "CpctyConfGrp",
                    "abbrName": "Cpcty",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.4.4",
                    "updatedEP": "97",
                    "category": "Confirmation",
                    "id": "2013",
                    "numInGroup": { "id": "862", "added": "FIX.4.4", "updated": "FIX.5.0SP1", "updatedEP": "95" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "528",
                            "presence": "required",
                            "description": "Specifies the capacity of the firm executing the order(s)",
                            "name": "OrderCapacity"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Confirmation messages are used to provide individual trade level confirmations from the sell side to the buy side. In versions of FIX prior to version 4.4, this role was performed by the allocation message. Unlike the allocation message, the confirmation message operates at an allocation account (trade) level rather than block level, allowing for the affirmation or rejection of individual confirmations."
    },
    "AL": {
        "name": "PositionMaintenanceRequest",
        "abbrName": "PosMntReq",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "AL",
        "id": "71",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "709",
                "presence": "required",
                "data": {
                    "type": "PosTransTypeCodeSet",
                    "name": "PosTransType",
                    "abbrName": "TxnTyp",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "199",
                    "id": "709",
                    "description": "Identifies the type of position transaction."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "712",
                "presence": "required",
                "data": {
                    "type": "PosMaintActionCodeSet",
                    "name": "PosMaintAction",
                    "abbrName": "Actn",
                    "added": "FIX.4.4",
                    "id": "712",
                    "description": "Maintenance Action to be performed."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "715",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "ClearingBusinessDate",
                    "abbrName": "BizDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "150",
                    "id": "715",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1015",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "PositionQty",
                    "abbrName": "Qty",
                    "added": "FIX.4.4",
                    "category": "Common",
                    "id": "1015",
                    "numInGroup": { "id": "702", "added": "FIX.4.4" },
                    "description": "The PositionQty component block specifies the various types of position quantity in the position life-cycle including start-of-day, intraday, trade, adjustments, and end-of-day position quantities. Quantities are expressed in terms of long and short quantities.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Position Maintenance Request message allows the position owner to submit requests to the holder of a position which will result in a specific action being taken which will affect the position. Generally, the holder of the position is a central counter party or clearing organization but can also be a party providing investment services."
    },
    "AM": {
        "name": "PositionMaintenanceReport",
        "abbrName": "PosMntRpt",
        "updated": "FIX.Latest",
        "added": "FIX.4.4",
        "updatedEP": "271",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "AM",
        "id": "72",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "709",
                "presence": "required",
                "data": {
                    "type": "PosTransTypeCodeSet",
                    "name": "PosTransType",
                    "abbrName": "TxnTyp",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "199",
                    "id": "709",
                    "description": "Identifies the type of position transaction."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "712",
                "presence": "required",
                "data": {
                    "type": "PosMaintActionCodeSet",
                    "name": "PosMaintAction",
                    "abbrName": "Actn",
                    "added": "FIX.4.4",
                    "id": "712",
                    "description": "Maintenance Action to be performed."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "715",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "ClearingBusinessDate",
                    "abbrName": "BizDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "150",
                    "id": "715",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "721",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PosMaintRptID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "721",
                    "description": "Unique identifier for this position report"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Position Maintenance Report message is sent by the holder of a position in response to a Position Maintenance Request and is used to confirm that a request has been successfully processed or rejected."
    },
    "AN": {
        "name": "RequestForPositions",
        "abbrName": "ReqForPoss",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "AN",
        "id": "73",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "710",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PosReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.4",
                    "id": "710",
                    "description": "Unique identifier for the position maintenance request as assigned by the submitter"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "715",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "ClearingBusinessDate",
                    "abbrName": "BizDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "150",
                    "id": "715",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "724",
                "presence": "required",
                "data": {
                    "type": "PosReqTypeCodeSet",
                    "name": "PosReqType",
                    "abbrName": "ReqTyp",
                    "added": "FIX.4.4",
                    "id": "724",
                    "description": "Used to specify the type of position request being made."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Request For Positions message is used by the owner of a position to request a Position Report from the holder of the position, usually the central counter party or clearing organization. The request can be made at several levels of granularity."
    },
    "AO": {
        "name": "RequestForPositionsAck",
        "abbrName": "ReqForPossAck",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "AO",
        "id": "74",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "721",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PosMaintRptID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "721",
                    "description": "Unique identifier for this position report"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "728",
                "presence": "required",
                "data": {
                    "type": "PosReqResultCodeSet",
                    "name": "PosReqResult",
                    "abbrName": "Rslt",
                    "unionDataType": "Reserved100Plus",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "204",
                    "id": "728",
                    "description": "Result of Request for Positions."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "729",
                "presence": "required",
                "data": {
                    "type": "PosReqStatusCodeSet",
                    "name": "PosReqStatus",
                    "abbrName": "Stat",
                    "added": "FIX.4.4",
                    "id": "729",
                    "description": "Status of Request for Positions"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Request for Positions Ack message is returned by the holder of the position in response to a Request for Positions message. The purpose of the message is to acknowledge that a request has been received and is being processed."
    },
    "AP": {
        "name": "PositionReport",
        "abbrName": "PosRpt",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "AP",
        "id": "75",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "715",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "ClearingBusinessDate",
                    "abbrName": "BizDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "150",
                    "id": "715",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "721",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PosMaintRptID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "721",
                    "description": "Unique identifier for this position report"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Position Report message is returned by the holder of a position in response to a Request for Position message. The purpose of the message is to report all aspects of a position and may be provided on a standing basis to report end of day positions to an owner."
    },
    "AQ": {
        "name": "TradeCaptureReportRequestAck",
        "abbrName": "TrdCaptRptReqAck",
        "updated": "FIX.5.0SP2",
        "added": "FIX.4.4",
        "updatedEP": "192",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "tradecapture",
            "name": "TradeCapture"
        },
        "msgType": "AQ",
        "id": "76",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "568",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TradeRequestID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.3",
                    "id": "568",
                    "description": "Trade Capture Report Request ID"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "569",
                "presence": "required",
                "data": {
                    "type": "TradeRequestTypeCodeSet",
                    "name": "TradeRequestType",
                    "abbrName": "ReqTyp",
                    "added": "FIX.4.3",
                    "id": "569",
                    "description": "Type of Trade Capture Report."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "749",
                "presence": "required",
                "data": {
                    "type": "TradeRequestResultCodeSet",
                    "name": "TradeRequestResult",
                    "abbrName": "ReqRslt",
                    "unionDataType": "Reserved100Plus",
                    "added": "FIX.4.4",
                    "id": "749",
                    "description": "Result of Trade Request"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "750",
                "presence": "required",
                "data": {
                    "type": "TradeRequestStatusCodeSet",
                    "name": "TradeRequestStatus",
                    "abbrName": "ReqStat",
                    "added": "FIX.4.4",
                    "id": "750",
                    "description": "Status of Trade Request."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Trade Capture Request Ack message is used to:\n\n- Provide an acknowledgement to a Trade Capture Report Request in the case where the Trade Capture Report Request is used to specify a subscription or delivery of reports via an out-of-band ResponseTransmissionMethod.\n\n- Provide an acknowledgement to a Trade Capture Report Request in the case when the return of the Trade Capture Reports matching that request will be delayed or delivered asynchronously. This is useful in distributed trading system environments.\n\n- Indicate that no trades were found that matched the selection criteria specified on the Trade Capture Report Request or the Trade Capture Request was invalid for some business reason, such as request is not authorized, invalid or unknown instrument, party, trading session, etc."
    },
    "AR": {
        "name": "TradeCaptureReportAck",
        "abbrName": "TrdCaptRptAck",
        "updated": "FIX.5.0SP2",
        "added": "FIX.4.4",
        "updatedEP": "192",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "tradecapture",
            "name": "TradeCapture"
        },
        "msgType": "AR",
        "id": "77",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.4",
                "updatedEP": "141",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Trade Capture Report Ack message can be:\n\n- Used to acknowledge trade capture reports received from a counterparty.\n\n- Used to reject a trade capture report received from a counterparty."
    },
    "AS": {
        "name": "AllocationReport",
        "abbrName": "AllocRpt",
        "updated": "FIX.Latest",
        "added": "FIX.4.4",
        "updatedEP": "291",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "allocation",
            "name": "Allocation"
        },
        "msgType": "AS",
        "id": "78",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP1",
                "added": "FIX.4.4",
                "updatedEP": "82",
                "id": "6",
                "presence": "required",
                "data": {
                    "type": "Price",
                    "name": "AvgPx",
                    "abbrName": "AvgPx",
                    "added": "FIX.2.7",
                    "id": "6",
                    "description": "Calculated average price of all fills on this order.\n\nFor Fixed Income trades AvgPx is always expressed as percent-of-par, regardless of the PriceType (423) of LastPx (31). I.e., AvgPx will contain an average of percent-of-par values (see LastParPx (669)) for issues traded in Yield, Spread or Discount."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "53",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "name": "Quantity",
                    "abbrName": "Qty",
                    "added": "FIX.2.7",
                    "id": "53",
                    "description": "Overall/total quantity (e.g. number of shares)\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "updated": "FIX.Latest",
                "added": "FIX.4.4",
                "updatedEP": "285",
                "id": "71",
                "presence": "required",
                "data": {
                    "type": "AllocTransTypeCodeSet",
                    "name": "AllocTransType",
                    "abbrName": "TransTyp",
                    "added": "FIX.2.7",
                    "id": "71",
                    "description": "Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "75",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "TradeDate",
                    "abbrName": "TrdDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.2.7",
                    "updatedEP": "190",
                    "id": "75",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "87",
                "presence": "required",
                "data": {
                    "type": "AllocStatusCodeSet",
                    "baseCategory": "Allocation",
                    "name": "AllocStatus",
                    "abbrName": "Stat",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "Stat",
                    "id": "87",
                    "description": "Identifies status of allocation."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "755",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AllocReportID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "755",
                    "description": "Unique identifier for Allocation Report message."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "794",
                "presence": "required",
                "data": {
                    "type": "AllocReportTypeCodeSet",
                    "name": "AllocReportType",
                    "abbrName": "RptTyp",
                    "added": "FIX.4.4",
                    "id": "794",
                    "description": "Describes the specific type or purpose of an Allocation Report message"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updated": "FIX.Latest",
                "added": "FIX.4.4",
                "updatedEP": "282",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Sent from sell-side to buy-side, sell-side to 3rd-party or 3rd-party to buy-side, the AllocationReport(35=AS) message (Claim) provides account breakdown of an order or set of orders plus any additional follow-up front-office information developed post-trade during the trade allocation, matching and calculation phase.\n\nIn versions of the FIX Protocol prior to version 4.4, this functionality was provided through the Allocation(35=J) message. Depending on the needs of the market and the timing of confirmed status, the role of AllocationReport(35=AS) can be taken over in whole or in part by the Confirmation(35=AK) message."
    },
    "AT": {
        "name": "AllocationReportAck",
        "abbrName": "AllocRptAck",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "allocation",
            "name": "Allocation"
        },
        "msgType": "AT",
        "id": "79",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "755",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AllocReportID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "755",
                    "description": "Unique identifier for Allocation Report message."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Allocation Report Ack message is used to acknowledge the receipt of and provide status for an Allocation Report message."
    },
    "AU": {
        "name": "ConfirmationAck",
        "abbrName": "CnfmAck",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "confirmation",
            "name": "Confirmation"
        },
        "msgType": "AU",
        "id": "80",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "75",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "TradeDate",
                    "abbrName": "TrdDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.2.7",
                    "updatedEP": "190",
                    "id": "75",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "664",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ConfirmID",
                    "abbrName": "CnfmID",
                    "added": "FIX.4.4",
                    "id": "664",
                    "description": "Message reference for Confirmation"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "940",
                "presence": "required",
                "data": {
                    "type": "AffirmStatusCodeSet",
                    "name": "AffirmStatus",
                    "abbrName": "AffirmStat",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "215",
                    "id": "940",
                    "description": "Specifies the affirmation status of the confirmation."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Confirmation Ack (aka Affirmation) message is used to respond to a Confirmation message."
    },
    "AV": {
        "name": "SettlementInstructionRequest",
        "abbrName": "SettlInstrctnReq",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "settlement",
            "name": "SettlementInstruction"
        },
        "msgType": "AV",
        "id": "81",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "791",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SettlInstReqID",
                    "abbrName": "SettlInstReqID",
                    "added": "FIX.4.4",
                    "id": "791",
                    "description": "Unique ID of settlement instruction request message"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Settlement Instruction Request message is used to request standing settlement instructions from another party."
    },
    "AW": {
        "name": "AssignmentReport",
        "abbrName": "AsgnRpt",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "AW",
        "id": "82",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "715",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "ClearingBusinessDate",
                    "abbrName": "BizDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "150",
                    "id": "715",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "833",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AsgnRptID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "833",
                    "description": "Unique identifier for the Assignment Report"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Assignment Reports are sent from a clearing house to counterparties, such as a clearing firm as a result of the assignment process."
    },
    "AX": {
        "name": "CollateralRequest",
        "abbrName": "CollReq",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "collateral",
            "name": "CollateralManagement"
        },
        "msgType": "AX",
        "id": "83",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "894",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CollReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.4",
                    "id": "894",
                    "description": "Collateral Request Identifier"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "895",
                "presence": "required",
                "data": {
                    "type": "CollAsgnReasonCodeSet",
                    "name": "CollAsgnReason",
                    "abbrName": "AsgnRsn",
                    "added": "FIX.4.4",
                    "id": "895",
                    "description": "Reason for Collateral Assignment"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "An initiator that requires collateral from a respondent sends a Collateral Request. The initiator can be either counterparty to a trade in a two party model or an intermediary such as an ATS or clearinghouse in a three party model. A Collateral Assignment is expected as a response to a request for collateral."
    },
    "AY": {
        "name": "CollateralAssignment",
        "abbrName": "CollAsgn",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "collateral",
            "name": "CollateralManagement"
        },
        "msgType": "AY",
        "id": "84",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "895",
                "presence": "required",
                "data": {
                    "type": "CollAsgnReasonCodeSet",
                    "name": "CollAsgnReason",
                    "abbrName": "AsgnRsn",
                    "added": "FIX.4.4",
                    "id": "895",
                    "description": "Reason for Collateral Assignment"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "902",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CollAsgnID",
                    "abbrName": "ID",
                    "added": "FIX.4.4",
                    "id": "902",
                    "description": "Collateral Assignment Identifier"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "903",
                "presence": "required",
                "data": {
                    "type": "CollAsgnTransTypeCodeSet",
                    "name": "CollAsgnTransType",
                    "abbrName": "TransTyp",
                    "added": "FIX.4.4",
                    "id": "903",
                    "description": "Collateral Assignment Transaction Type"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to assign collateral to cover a trading position. This message can be sent unsolicited or in reply to a Collateral Request message."
    },
    "AZ": {
        "name": "CollateralResponse",
        "abbrName": "CollRsp",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "collateral",
            "name": "CollateralManagement"
        },
        "msgType": "AZ",
        "id": "85",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "904",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CollRespID",
                    "abbrName": "RespID",
                    "added": "FIX.4.4",
                    "id": "904",
                    "description": "Collateral Response Identifier"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "905",
                "presence": "required",
                "data": {
                    "type": "CollAsgnRespTypeCodeSet",
                    "name": "CollAsgnRespType",
                    "abbrName": "RespTyp",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "192",
                    "id": "905",
                    "description": "Type of collateral assignment response."
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "added": "FIX.4.4",
                "updatedEP": "193",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to respond to a Collateral Assignment message."
    },
    "BA": {
        "name": "CollateralReport",
        "abbrName": "CollRpt",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "collateral",
            "name": "CollateralManagement"
        },
        "msgType": "BA",
        "id": "86",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "908",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CollRptID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "908",
                    "description": "Collateral Report Identifier"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "910",
                "presence": "required",
                "data": {
                    "type": "CollStatusCodeSet",
                    "name": "CollStatus",
                    "abbrName": "Stat",
                    "added": "FIX.4.4",
                    "id": "910",
                    "description": "Collateral Status"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to report collateral status when responding to a Collateral Inquiry message."
    },
    "BB": {
        "name": "CollateralInquiry",
        "abbrName": "CollInq",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "collateral",
            "name": "CollateralManagement"
        },
        "msgType": "BB",
        "id": "87",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP1",
                "added": "FIX.4.4",
                "updatedEP": "95",
                "id": "909",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CollInquiryID",
                    "abbrName": "ID",
                    "added": "FIX.4.4",
                    "id": "909",
                    "description": "Collateral Inquiry Identifier"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to inquire for collateral status."
    },
    "BC": {
        "name": "NetworkCounterpartySystemStatusRequest",
        "abbrName": "NtwkSysStatReq",
        "added": "FIX.4.4",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "network",
            "name": "Network"
        },
        "msgType": "BC",
        "id": "88",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "933",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "NetworkRequestID",
                    "abbrName": "NtwkReqID",
                    "added": "FIX.4.4",
                    "id": "933",
                    "description": "Unique identifier for a network resquest."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "935",
                "presence": "required",
                "data": {
                    "type": "NetworkRequestTypeCodeSet",
                    "name": "NetworkRequestType",
                    "abbrName": "NtwkReqTyp",
                    "added": "FIX.4.4",
                    "id": "935",
                    "description": "Indicates the type and level of details required for a Network Status Request Message\n\nBoolean logic applies EG If you want to subscribe for changes to certain id's then UserRequestType =0 (8+2), Snapshot for certain ID's = 9 (8+1)"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is send either immediately after logging on to inform a network (counterparty system) of the type of updates required or to at any other time in the FIX conversation to change the nature of the types of status updates required. It can also be used with a NetworkRequestType of Snapshot to request a one-off report of the status of a network (or counterparty) system. Finally this message can also be used to cancel a request to receive updates into the status of the counterparties on a network by sending a NetworkRequestStatusMessage with a NetworkRequestType of StopSubscribing."
    },
    "BD": {
        "name": "NetworkCounterpartySystemStatusResponse",
        "abbrName": "NtwkSysStatRsp",
        "added": "FIX.4.4",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "network",
            "name": "Network"
        },
        "msgType": "BD",
        "id": "89",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "932",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "NetworkResponseID",
                    "abbrName": "NtwkRspID",
                    "added": "FIX.4.4",
                    "id": "932",
                    "description": "Unique identifier for a network response."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "937",
                "presence": "required",
                "data": {
                    "type": "NetworkStatusResponseTypeCodeSet",
                    "name": "NetworkStatusResponseType",
                    "abbrName": "NtwkStatRspTyp",
                    "added": "FIX.4.4",
                    "id": "937",
                    "description": "Indicates the type of Network Response Message."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "2010",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "CompIDStatGrp",
                    "abbrName": "CIDStat",
                    "added": "FIX.4.4",
                    "category": "Common",
                    "id": "2010",
                    "numInGroup": { "id": "936", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "id": "930",
                            "presence": "required",
                            "description": "CompID that status is being report for. Required if NoCompIDs > 0,",
                            "name": "RefCompID"
                        },
                        {
                            "added": "FIX.4.4",
                            "id": "928",
                            "presence": "required",
                            "description": "",
                            "name": "StatusValue"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is sent in response to a Network (Counterparty System) Status Request Message."
    },
    "BE": {
        "name": "UserRequest",
        "abbrName": "UserReq",
        "added": "FIX.4.4",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "usermanagement",
            "name": "UserManagement"
        },
        "msgType": "BE",
        "id": "90",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "553",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "Username",
                    "abbrName": "Username",
                    "added": "FIX.4.3",
                    "id": "553",
                    "description": "Userid or username."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "923",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "UserRequestID",
                    "abbrName": "UserReqID",
                    "added": "FIX.4.4",
                    "id": "923",
                    "description": "Unique identifier for a User Request."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "924",
                "presence": "required",
                "data": {
                    "type": "UserRequestTypeCodeSet",
                    "name": "UserRequestType",
                    "abbrName": "UserReqTyp",
                    "added": "FIX.4.4",
                    "id": "924",
                    "description": "Indicates the action required by a User Request Message"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used to initiate a user action, logon, logout or password change. It can also be used to request a report on a user's status."
    },
    "BF": {
        "name": "UserResponse",
        "abbrName": "UserRsp",
        "added": "FIX.4.4",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "usermanagement",
            "name": "UserManagement"
        },
        "msgType": "BF",
        "id": "91",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "553",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "Username",
                    "abbrName": "Username",
                    "added": "FIX.4.3",
                    "id": "553",
                    "description": "Userid or username."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "923",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "UserRequestID",
                    "abbrName": "UserReqID",
                    "added": "FIX.4.4",
                    "id": "923",
                    "description": "Unique identifier for a User Request."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used to respond to a user request message, it reports the status of the user after the completion of any action requested in the user request message."
    },
    "BG": {
        "name": "CollateralInquiryAck",
        "abbrName": "CollInqAck",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "collateral",
            "name": "CollateralManagement"
        },
        "msgType": "BG",
        "id": "92",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "909",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CollInquiryID",
                    "abbrName": "ID",
                    "added": "FIX.4.4",
                    "id": "909",
                    "description": "Collateral Inquiry Identifier"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "945",
                "presence": "required",
                "data": {
                    "type": "CollInquiryStatusCodeSet",
                    "name": "CollInquiryStatus",
                    "abbrName": "Stat",
                    "added": "FIX.4.4",
                    "id": "945",
                    "description": "Status of Collateral Inquiry"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to respond to a Collateral Inquiry in the following situations:\n\n• When the CollateralInquiry will result in an out of band response (such as a file transfer).\n\n• When the inquiry is otherwise valid but no collateral is found to match the criteria specified on the Collateral Inquiry message.\n\n• When the Collateral Inquiry is invalid based upon the business rules of the counterparty."
    },
    "BH": {
        "name": "ConfirmationRequest",
        "abbrName": "CnfmReq",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "confirmation",
            "name": "Confirmation"
        },
        "msgType": "BH",
        "id": "93",
        "structure": [
            {
                "added": "FIX.4.4",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "773",
                "presence": "required",
                "data": {
                    "type": "ConfirmTypeCodeSet",
                    "name": "ConfirmType",
                    "abbrName": "CnfmTyp",
                    "added": "FIX.4.4",
                    "id": "773",
                    "description": "Identifies the type of Confirmation message being sent."
                }
            },
            {
                "added": "FIX.4.4",
                "id": "859",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ConfirmReqID",
                    "abbrName": "CnfmReqID",
                    "added": "FIX.4.4",
                    "id": "859",
                    "description": "Unique identifier for a Confirmation Request message"
                }
            },
            {
                "added": "FIX.4.4",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Confirmation Request message is used to request a Confirmation message."
    },
    "BO": {
        "name": "ContraryIntentionReport",
        "abbrName": "ContIntRpt",
        "addedEP": "-1",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "BO",
        "id": "94",
        "structure": [
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "715",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "ClearingBusinessDate",
                    "abbrName": "BizDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "150",
                    "id": "715",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "977",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ContIntRptID",
                    "abbrName": "RptID",
                    "addedEP": "4",
                    "added": "FIX.4.4",
                    "id": "977",
                    "description": "Unique identifier for the Contrary Intention report"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1027",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "ExpirationQty",
                    "abbrName": "Qty",
                    "updated": "FIX.5.0SP1",
                    "addedEP": "-1",
                    "added": "FIX.4.4",
                    "updatedEP": "97",
                    "category": "PositionMaintenance",
                    "id": "1027",
                    "numInGroup": { "id": "981", "added": "FIX.4.4", "addedEP": "-1" },
                    "description": "The ExpirationQty component block identified the expiration quantities and type of expiration.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Contrary Intention Report is used for reporting of contrary expiration quantities for Saturday expiring options. This information is required by options exchanges for regulatory purposes."
    },
    "BP": {
        "name": "SecurityDefinitionUpdateReport",
        "abbrName": "SecDefUpd",
        "updated": "FIX.5.0SP2",
        "addedEP": "-1",
        "added": "FIX.4.4",
        "updatedEP": "195",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "BP",
        "id": "95",
        "structure": [
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "This message is used for reporting updates to a product security master file. Updates could be the result of corporate actions or other business events. Updates may include additions, modifications or deletions."
    },
    "BK": {
        "name": "SecurityListUpdateReport",
        "abbrName": "SecListUpd",
        "updated": "FIX.5.0SP1",
        "addedEP": "-1",
        "added": "FIX.4.4",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "BK",
        "id": "96",
        "structure": [
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security List Update Report is used for reporting updates to a Contract Security Masterfile. Updates could be due to Corporate Actions or other business events. Update may include additions, modifications and deletions."
    },
    "BL": {
        "name": "AdjustedPositionReport",
        "abbrName": "AdjPosRep",
        "addedEP": "-1",
        "added": "FIX.4.4",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "BL",
        "id": "97",
        "structure": [
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "715",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "ClearingBusinessDate",
                    "abbrName": "BizDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "150",
                    "id": "715",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "721",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PosMaintRptID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "721",
                    "description": "Unique identifier for this position report"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1015",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "PositionQty",
                    "abbrName": "Qty",
                    "added": "FIX.4.4",
                    "category": "Common",
                    "id": "1015",
                    "numInGroup": { "id": "702", "added": "FIX.4.4" },
                    "description": "The PositionQty component block specifies the various types of position quantity in the position life-cycle including start-of-day, intraday, trade, adjustments, and end-of-day position quantities. Quantities are expressed in terms of long and short quantities.\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to report changes in position, primarily in equity options, due to modifications to the underlying due to corporate actions"
    },
    "BM": {
        "name": "AllocationInstructionAlert",
        "abbrName": "AllocInstrAlert",
        "updated": "FIX.Latest",
        "addedEP": "-1",
        "added": "FIX.4.4",
        "updatedEP": "285",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "allocation",
            "name": "Allocation"
        },
        "msgType": "BM",
        "id": "98",
        "structure": [
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "70",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "Allocation",
                    "name": "AllocID",
                    "abbrName": "AllocID",
                    "added": "FIX.2.7",
                    "baseCategoryAbbrName": "ID",
                    "id": "70",
                    "description": "Unique identifier for allocation message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "-1",
                "added": "FIX.4.4",
                "updatedEP": "285",
                "id": "71",
                "presence": "required",
                "data": {
                    "type": "AllocTransTypeCodeSet",
                    "name": "AllocTransType",
                    "abbrName": "TransTyp",
                    "added": "FIX.2.7",
                    "id": "71",
                    "description": "Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "75",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "TradeDate",
                    "abbrName": "TrdDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.2.7",
                    "updatedEP": "190",
                    "id": "75",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "626",
                "presence": "required",
                "data": {
                    "type": "AllocTypeCodeSet",
                    "baseCategory": "Allocation",
                    "name": "AllocType",
                    "abbrName": "AllocType",
                    "added": "FIX.4.3",
                    "baseCategoryAbbrName": "Typ",
                    "id": "626",
                    "description": "Describes the specific type or purpose of an Allocation message (i.e. \"Buyside Calculated\")\n\n(see Volume : \"Glossary\" for value definitions)\n\n*** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "This message is used in a 3-party allocation model (buy-side and sell-side using a central clearing entity) where notification of group creation and group updates to counterparties is needed. The message will also carry trade information that comprised the group to the counterparties."
    },
    "BN": {
        "name": "ExecutionAck",
        "abbrName": "ExecAck",
        "updated": "FIX.5.0SP2",
        "addedEP": "-1",
        "added": "FIX.4.4",
        "updatedEP": "143",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "order",
            "name": "SingleGeneralOrderHandling"
        },
        "msgType": "BN",
        "id": "99",
        "structure": [
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "17",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ExecID",
                    "abbrName": "ExecID",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "95",
                    "id": "17",
                    "description": "Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\n\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n\n(Prior to FIX 4.1 this field was of type int)."
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "37",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "OrderID",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1036",
                "presence": "required",
                "data": {
                    "type": "ExecAckStatusCodeSet",
                    "name": "ExecAckStatus",
                    "abbrName": "ExecAckStat",
                    "addedEP": "10",
                    "added": "FIX.4.4",
                    "id": "1036",
                    "description": "The status of this execution acknowledgement message."
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The Execution Report Acknowledgement message is an optional message that provides dual functionality to notify a trading partner that an electronically received execution has either been accepted or rejected (DK'd)."
    },
    "BJ": {
        "name": "TradingSessionList",
        "abbrName": "TradSessList",
        "updated": "FIX.5.0SP1",
        "addedEP": "-1",
        "added": "FIX.4.4",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "marketstructure",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "msgType": "BJ",
        "id": "100",
        "structure": [
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "2099",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "TrdSessLstGrp",
                    "abbrName": "TrdSessLstGrp",
                    "addedEP": "-1",
                    "added": "FIX.4.4",
                    "category": "Common",
                    "id": "2099",
                    "numInGroup": { "id": "386", "added": "FIX.4.4", "addedEP": "-1" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "addedEP": "-1",
                            "id": "336",
                            "presence": "required",
                            "description": "Identifier for Trading Session",
                            "name": "TradingSessionID"
                        },
                        {
                            "added": "FIX.4.4",
                            "addedEP": "-1",
                            "id": "340",
                            "presence": "required",
                            "description": "State of trading session.",
                            "name": "TradSesStatus"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session List message is sent as a response to a Trading Session List Request. The Trading Session List should contain the characteristics of the trading session and the current state of the trading session."
    },
    "BI": {
        "name": "TradingSessionListRequest",
        "abbrName": "TradSessListReq",
        "updated": "FIX.5.0SP1",
        "addedEP": "-1",
        "added": "FIX.4.4",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "marketstructure",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "msgType": "BI",
        "id": "101",
        "structure": [
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "263",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "name": "SubscriptionRequestType",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "-1",
                "added": "FIX.4.4",
                "updatedEP": "294",
                "id": "335",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TradSesReqID",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "id": "335",
                    "description": "Unique ID of a Trading Session Status message."
                }
            },
            {
                "added": "FIX.4.4",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session List Request is used to request a list of trading sessions available in a market place and the state of those trading sessions. A successful request will result in a response from the counterparty of a Trading Session List (MsgType=BJ) message that contains a list of zero or more trading sessions."
    },
    "BQ": {
        "name": "SettlementObligationReport",
        "abbrName": "SettlObligation",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "settlement",
            "name": "SettlementInstruction"
        },
        "msgType": "BQ",
        "id": "102",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1159",
                "presence": "required",
                "data": {
                    "type": "SettlObligModeCodeSet",
                    "name": "SettlObligMode",
                    "abbrName": "SettlMode",
                    "addedEP": "44",
                    "added": "FIX.5.0",
                    "id": "1159",
                    "description": "Used to identify the reporting mode of the settlement obligation which is either preliminary or final"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1160",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SettlObligMsgID",
                    "abbrName": "SettlMsgID",
                    "addedEP": "44",
                    "added": "FIX.5.0",
                    "id": "1160",
                    "description": "Message identifier for Settlement Obligation Report"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "2101",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "SettlObligationInstructions",
                    "abbrName": "SettlObligInst",
                    "addedEP": "-1",
                    "added": "FIX.5.0",
                    "category": "SettlementInstruction",
                    "id": "2101",
                    "numInGroup": { "id": "1165", "added": "FIX.5.0", "addedEP": "-1" },
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Settlement Obligation Report message provides a central counterparty, institution, or individual counterparty with a capacity for reporting the final details of a currency settlement obligation."
    },
    "BR": {
        "name": "DerivativeSecurityListUpdateReport",
        "abbrName": "DerivSecListUpd",
        "updated": "FIX.5.0SP1",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "BR",
        "id": "103",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Derivative Security List Update Report message is used to send updates to an option family or the strikes that comprise an option family."
    },
    "BS": {
        "name": "TradingSessionListUpdateReport",
        "abbrName": "TrdgSesListUpd",
        "updated": "FIX.5.0SP1",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "marketstructure",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "msgType": "BS",
        "id": "104",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "2099",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "TrdSessLstGrp",
                    "abbrName": "TrdSessLstGrp",
                    "addedEP": "-1",
                    "added": "FIX.4.4",
                    "category": "Common",
                    "id": "2099",
                    "numInGroup": { "id": "386", "added": "FIX.4.4", "addedEP": "-1" },
                    "fieldRef": [
                        {
                            "added": "FIX.4.4",
                            "addedEP": "-1",
                            "id": "336",
                            "presence": "required",
                            "description": "Identifier for Trading Session",
                            "name": "TradingSessionID"
                        },
                        {
                            "added": "FIX.4.4",
                            "addedEP": "-1",
                            "id": "340",
                            "presence": "required",
                            "description": "State of trading session.",
                            "name": "TradSesStatus"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session List Update Report is used by marketplaces to provide intra-day updates of trading sessions when there are changes to one or more trading sessions."
    },
    "BT": {
        "name": "MarketDefinitionRequest",
        "abbrName": "MktDefReq",
        "updated": "FIX.5.0SP1",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "updatedEP": "97",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "marketstructure",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "msgType": "BT",
        "id": "105",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "263",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "name": "SubscriptionRequestType",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1393",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MarketReqID",
                    "abbrName": "MktReqID",
                    "addedEP": "53",
                    "added": "FIX.5.0",
                    "id": "1393",
                    "description": "Unique ID of a Market Definition Request message."
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Market Definition Request message is used to request for market structure information from the Respondent that receives this request."
    },
    "BU": {
        "name": "MarketDefinition",
        "abbrName": "MktDef",
        "updated": "FIX.5.0SP2",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "updatedEP": "195",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "marketstructure",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "msgType": "BU",
        "id": "106",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1301",
                "presence": "required",
                "data": {
                    "type": "Exchange",
                    "name": "MarketID",
                    "abbrName": "MktID",
                    "updated": "FIX.5.0SP2",
                    "addedEP": "52",
                    "added": "FIX.5.0",
                    "updatedEP": "190",
                    "id": "1301",
                    "description": "Identifies the market"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "-1",
                "added": "FIX.5.0",
                "updatedEP": "195",
                "id": "1394",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MarketReportID",
                    "abbrName": "MktRptID",
                    "addedEP": "53",
                    "added": "FIX.5.0",
                    "id": "1394",
                    "description": "Market Definition message identifier."
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The MarketDefinition(35=BU) message is used to respond to MarketDefinitionRequest(35=BT). In a subscription, it will be used to provide the initial snapshot of the information requested. Subsequent updates are provided by the MarketDefinitionUpdateReport(35=BV)."
    },
    "BV": {
        "name": "MarketDefinitionUpdateReport",
        "abbrName": "MktDefUpd",
        "updated": "FIX.5.0SP2",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "updatedEP": "195",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "marketstructure",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "msgType": "BV",
        "id": "107",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1301",
                "presence": "required",
                "data": {
                    "type": "Exchange",
                    "name": "MarketID",
                    "abbrName": "MktID",
                    "updated": "FIX.5.0SP2",
                    "addedEP": "52",
                    "added": "FIX.5.0",
                    "updatedEP": "190",
                    "id": "1301",
                    "description": "Identifies the market"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "-1",
                "added": "FIX.5.0",
                "updatedEP": "195",
                "id": "1394",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MarketReportID",
                    "abbrName": "MktRptID",
                    "addedEP": "53",
                    "added": "FIX.5.0",
                    "id": "1394",
                    "description": "Market Definition message identifier."
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "In a subscription for market structure information, this message is used once the initial snapshot of the information has been sent using the MarketDefinition(35=BU) message."
    },
    "CB": {
        "name": "UserNotification",
        "abbrName": "UserNotifctn",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "usermanagement",
            "name": "UserManagement"
        },
        "msgType": "CB",
        "id": "113",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "926",
                "presence": "required",
                "data": {
                    "type": "UserStatusCodeSet",
                    "name": "UserStatus",
                    "abbrName": "UserStat",
                    "added": "FIX.4.4",
                    "id": "926",
                    "description": "Indicates the status of a user"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "The User Notification message is used to notify one or more users of an event or information from the sender of the message. This message is usually sent unsolicited from a marketplace (e.g. Exchange, ECN) to a market participant."
    },
    "BZ": {
        "name": "OrderMassActionReport",
        "abbrName": "OrdMassActRpt",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "ordermasshandling",
            "name": "OrderMassHandling"
        },
        "msgType": "BZ",
        "id": "111",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1369",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MassActionReportID",
                    "abbrName": "MassActionReportID",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "id": "1369",
                    "description": "Unique identifier of Order Mass Cancel Report or Order Mass Action Report message as assigned by sell-side (broker, exchange, ECN)"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1373",
                "presence": "required",
                "data": {
                    "type": "MassActionTypeCodeSet",
                    "name": "MassActionType",
                    "abbrName": "MassActionType",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "id": "1373",
                    "description": "Specifies the type of action requested"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1374",
                "presence": "required",
                "data": {
                    "type": "MassActionScopeCodeSet",
                    "name": "MassActionScope",
                    "abbrName": "MassActionScope",
                    "unionDataType": "Reserved100Plus",
                    "updated": "FIX.5.0SP1",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "updatedEP": "85",
                    "id": "1374",
                    "description": "Specifies scope of Order Mass Action Request."
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "-1",
                "added": "FIX.5.0",
                "updatedEP": "223",
                "id": "1375",
                "presence": "required",
                "data": {
                    "type": "MassActionResponseCodeSet",
                    "name": "MassActionResponse",
                    "abbrName": "MassActionResponse",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "id": "1375",
                    "description": "Specifies the action taken by counterparty order handling system as a result of the action type indicated in MassActionType of the Order Mass Action Request."
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The Order Mass Action Report is used to acknowledge an Order Mass Action Request. Note that each affected order that is suspended or released or canceled is acknowledged with a separate Execution Report for each order."
    },
    "CA": {
        "name": "OrderMassActionRequest",
        "abbrName": "OrdMassActReq",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "ordermasshandling",
            "name": "OrderMassHandling"
        },
        "msgType": "CA",
        "id": "112",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "11",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "name": "ClOrdID",
                    "abbrName": "ClOrdID",
                    "updated": "FIX.Latest",
                    "added": "FIX.2.7",
                    "updatedEP": "282",
                    "baseCategoryAbbrName": "ID",
                    "id": "11",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1373",
                "presence": "required",
                "data": {
                    "type": "MassActionTypeCodeSet",
                    "name": "MassActionType",
                    "abbrName": "MassActionType",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "id": "1373",
                    "description": "Specifies the type of action requested"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1374",
                "presence": "required",
                "data": {
                    "type": "MassActionScopeCodeSet",
                    "name": "MassActionScope",
                    "abbrName": "MassActionScope",
                    "unionDataType": "Reserved100Plus",
                    "updated": "FIX.5.0SP1",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "updatedEP": "85",
                    "id": "1374",
                    "description": "Specifies scope of Order Mass Action Request."
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The Order Mass Action Request message can be used to request the suspension or release of a group of orders that match the criteria specified within the request. This is equivalent to individual Order Cancel Replace Requests for each order with or without adding \"S\" to the ExecInst values. It can also be used for mass order cancellation."
    },
    "BW": {
        "name": "ApplicationMessageRequest",
        "abbrName": "ApplMsgReq",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "application",
            "name": "Application"
        },
        "msgType": "BW",
        "id": "108",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1346",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ApplReqID",
                    "abbrName": "ApplReqID",
                    "addedEP": "63",
                    "added": "FIX.5.0",
                    "id": "1346",
                    "description": "Unique identifier for request"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1347",
                "presence": "required",
                "data": {
                    "type": "ApplReqTypeCodeSet",
                    "name": "ApplReqType",
                    "abbrName": "ApplReqTyp",
                    "addedEP": "63",
                    "added": "FIX.5.0",
                    "id": "1347",
                    "description": "Type of Application Message Request being made."
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used to request a retransmission of a set of one or more messages generated by the application specified in RefApplID (1355)."
    },
    "BX": {
        "name": "ApplicationMessageRequestAck",
        "abbrName": "ApplMsgReqAck",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "application",
            "name": "Application"
        },
        "msgType": "BX",
        "id": "109",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1353",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ApplResponseID",
                    "abbrName": "ApplRespID",
                    "addedEP": "63",
                    "added": "FIX.5.0",
                    "id": "1353",
                    "description": "Identifier for the Applicaton Message Request Ack"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used to acknowledge an Application Message Request providing a status on the request (i.e. whether successful or not). This message does not provide the actual content of the messages to be resent."
    },
    "BY": {
        "name": "ApplicationMessageReport",
        "abbrName": "ApplMsgRpt",
        "addedEP": "-1",
        "added": "FIX.5.0",
        "category": {
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "application",
            "name": "Application"
        },
        "msgType": "BY",
        "id": "110",
        "structure": [
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1356",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "ApplReportID",
                    "abbrName": "ApplRptID",
                    "addedEP": "63",
                    "added": "FIX.5.0",
                    "id": "1356",
                    "description": "Identifier for the Application Sequence Reset"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1426",
                "presence": "required",
                "data": {
                    "type": "ApplReportTypeCodeSet",
                    "name": "ApplReportType",
                    "abbrName": "ApplRptTyp",
                    "added": "FIX.5.0SP2",
                    "id": "1426",
                    "description": "Type of report"
                }
            },
            {
                "added": "FIX.5.0",
                "addedEP": "-1",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "4",
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used for three difference purposes: to reset the ApplSeqNum (1181) of a specified ApplID (1180). to indicate that the last message has been sent for a particular ApplID, or as a keep-alive mechanism for ApplIDs with infrequent message traffic."
    },
    "CC": {
        "name": "StreamAssignmentRequest",
        "abbrName": "StrmAsgnReq",
        "addedEP": "93",
        "added": "FIX.5.0SP1",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "CC",
        "id": "114",
        "structure": [
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1497",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "StreamAsgnReqID",
                    "abbrName": "ReqID",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "id": "1497",
                    "description": "Unique identifier for the stream assignment request provided by the requester."
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1498",
                "presence": "required",
                "data": {
                    "type": "StreamAsgnReqTypeCodeSet",
                    "name": "StreamAsgnReqType",
                    "abbrName": "AsgnReqTyp",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "id": "1498",
                    "description": "Type of stream assignment request."
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "2148",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "StrmAsgnReqGrp",
                    "abbrName": "Reqs",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "category": "MarketData",
                    "id": "2148",
                    "numInGroup": { "id": "1499", "added": "FIX.5.0SP1", "addedEP": "93" },
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "In certain markets where market data aggregators fan out to end clients the pricing streams provided by the price makers, the price maker may assign the clients to certain pricing streams that the price maker publishes via the aggregator. An example of this use is in the FX markets where clients may be assigned to different pricing streams based on volume bands and currency pairs."
    },
    "CD": {
        "name": "StreamAssignmentReport",
        "abbrName": "StrmAsgnRpt",
        "updated": "FIX.Latest",
        "addedEP": "93",
        "added": "FIX.5.0SP1",
        "updatedEP": "294",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "CD",
        "id": "115",
        "structure": [
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1501",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "StreamAsgnRptID",
                    "abbrName": "RptID",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "id": "1501",
                    "description": "Unique identifier of the stream assignment report provided by the respondent."
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The StreamAssignmentReport(35=CD) message is in response to the StreamAssignmentRequest(35=CC) message. It provides information back to the aggregator as to which clients to assign to receive which price stream based on requested CCY pair. This message can be sent unsolicited to the Aggregator from the Price Maker."
    },
    "CE": {
        "name": "StreamAssignmentReportACK",
        "abbrName": "StrmAsgnRptACK",
        "addedEP": "93",
        "added": "FIX.5.0SP1",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "CE",
        "id": "116",
        "structure": [
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1501",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "StreamAsgnRptID",
                    "abbrName": "RptID",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "id": "1501",
                    "description": "Unique identifier of the stream assignment report provided by the respondent."
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1503",
                "presence": "required",
                "data": {
                    "type": "StreamAsgnAckTypeCodeSet",
                    "name": "StreamAsgnAckType",
                    "abbrName": "ActTyp",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "id": "1503",
                    "description": "Type of acknowledgement."
                }
            },
            {
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "This message is used to respond to the Stream Assignment Report, to either accept or reject an unsolicited assingment."
    },
    "CH": {
        "name": "MarginRequirementInquiry",
        "abbrName": "MgnReqmtInq",
        "addedEP": "102",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "102",
            "FIXMLFileName": "marginrequirement",
            "added": "FIX.5.0SP2",
            "name": "MarginRequirementManagement"
        },
        "msgType": "CH",
        "id": "119",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1635",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MarginReqmtInqID",
                    "abbrName": "ID",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "id": "1635",
                    "description": "Unique identifier of the MarginRequirementInquiry."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "2176",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "MarginReqmtInqQualGrp",
                    "abbrName": "MgnReqmtInqQual",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "category": "MarginRequirementManagement",
                    "id": "2176",
                    "numInGroup": { "id": "1636", "added": "FIX.5.0SP2", "addedEP": "102" },
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The purpose of this message is to initiate a margin requirement inquiry for a margin account. The inquiry may be submitted at the detail level or the summary level. It can also be used to inquire margin excess/deficit or net position information. Margin excess/deficit will provide information about the surplus or shortfall compared to the previous trading day or a more recent margin calculation. An inquiry for net position information will trigger one or more PositionReport messages instead of one or more MarginRequirementReport messages.\n\nIf the inquiry is made at the detail level, an Instrument block must be provided with the desired level of detail. If the inquiry is made at the summary level, the Instrument block is not provided, implying a summary request is being made. For example, if the inquiring firm specifies the Security Type of “FUT” in the Instrument block, then a detail report will be generated containing the margin requirements for all futures positions for the inquiring account. Similarly, if the inquiry is made at the summary level, the report will contain the total margin requirement aggregated to the margin account level."
    },
    "CI": {
        "name": "MarginRequirementInquiryAck",
        "abbrName": "MgnReqmtInqAck",
        "addedEP": "102",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "102",
            "FIXMLFileName": "marginrequirement",
            "added": "FIX.5.0SP2",
            "name": "MarginRequirementManagement"
        },
        "msgType": "CI",
        "id": "120",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1635",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MarginReqmtInqID",
                    "abbrName": "ID",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "id": "1635",
                    "description": "Unique identifier of the MarginRequirementInquiry."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1640",
                "presence": "required",
                "data": {
                    "type": "CollInquiryStatusCodeSet",
                    "name": "MarginReqmtInqStatus",
                    "abbrName": "Stat",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "id": "1640",
                    "description": "Status of MarginRequirementInquiry."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "2176",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "MarginReqmtInqQualGrp",
                    "abbrName": "MgnReqmtInqQual",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "category": "MarginRequirementManagement",
                    "id": "2176",
                    "numInGroup": { "id": "1636", "added": "FIX.5.0SP2", "addedEP": "102" },
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to respond to a Margin Requirement Inquiry."
    },
    "CJ": {
        "name": "MarginRequirementReport",
        "abbrName": "MgnReqmtRpt",
        "addedEP": "102",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "102",
            "FIXMLFileName": "marginrequirement",
            "added": "FIX.5.0SP2",
            "name": "MarginRequirementManagement"
        },
        "msgType": "CJ",
        "id": "121",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1638",
                "presence": "required",
                "data": {
                    "type": "MarginReqmtRptTypeCodeSet",
                    "name": "MarginReqmtRptType",
                    "abbrName": "RptTyp",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "id": "1638",
                    "description": "Type of MarginRequirementReport."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1642",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MarginReqmtRptID",
                    "abbrName": "RptID",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "id": "1642",
                    "description": "Identifier for the MarginRequirementReport message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "2177",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "MarginAmount",
                    "abbrName": "MgnAmt",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "category": "Common",
                    "id": "2177",
                    "numInGroup": { "id": "1643", "added": "FIX.5.0SP2", "addedEP": "102" },
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Margin Requirement Report returns information about margin requirement either as on overview across all margin accounts or on a detailed level due to the inquiry making use of the optional Instrument component block. Application sequencing can be used to re-request a range of reports."
    },
    "CF": {
        "name": "PartyDetailsListRequest",
        "abbrName": "PtyDetlListReq",
        "addedEP": "105",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CF",
        "id": "117",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1505",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PartyDetailsListRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1505",
                    "description": "Unique identifier for PartyDetailsListRequest."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsListRequest is used to request party detail information."
    },
    "CG": {
        "name": "PartyDetailsListReport",
        "abbrName": "PtyDetlListRpt",
        "updated": "FIX.5.0SP2",
        "addedEP": "105",
        "added": "FIX.5.0SP2",
        "updatedEP": "146",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CG",
        "id": "118",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1510",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PartyDetailsListReportID",
                    "abbrName": "RptID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1510",
                    "description": "Identifier for the PartyDetailsListReport and the PartyDetailsListUpdateReport."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsListReport message is used to disseminate party details between counterparties. PartyDetailsListReport messages may be sent in response to a PartyDetailsListRequest message or sent unsolicited."
    },
    "CK": {
        "name": "PartyDetailsListUpdateReport",
        "abbrName": "PtyDetlListUpd",
        "updated": "FIX.5.0SP2",
        "addedEP": "105",
        "added": "FIX.5.0SP2",
        "updatedEP": "195",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CK",
        "id": "122",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1510",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PartyDetailsListReportID",
                    "abbrName": "RptID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1510",
                    "description": "Identifier for the PartyDetailsListReport and the PartyDetailsListUpdateReport."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsListUpdateReport(35=CK) is used to disseminate updates to party detail information."
    },
    "CL": {
        "name": "PartyRiskLimitsRequest",
        "abbrName": "PtyRiskLmtReq",
        "addedEP": "105",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CL",
        "id": "123",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1666",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "RiskLimitRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1666",
                    "description": "Unique identifier for the PartyRiskLimitsRequest"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyRiskLimitsRequest message is used to request for risk information for specific parties, specific party roles or specific instruments."
    },
    "CM": {
        "name": "PartyRiskLimitsReport",
        "abbrName": "PtyRiskLmtRpt",
        "addedEP": "105",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CM",
        "id": "124",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1667",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "RiskLimitReportID",
                    "abbrName": "RptID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1667",
                    "description": "Identifier for the PartyRiskLimitsReport"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyRiskLimitsReport message is used to communicate party risk limits. The message can either be sent as a response to the PartyRiskLimitsRequest message or can be published unsolicited."
    },
    "CN": {
        "name": "SecurityMassStatusRequest",
        "abbrName": "SecMassStatReq",
        "addedEP": "106",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "CN",
        "id": "125",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "id": "263",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "name": "SubscriptionRequestType",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "id": "324",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityStatusReqID",
                    "abbrName": "StatReqID",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.2",
                    "updatedEP": "106",
                    "id": "324",
                    "description": "Unique ID of a Security Status Request or a Security Mass Status Request message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": ""
    },
    "CO": {
        "name": "SecurityMassStatus",
        "abbrName": "SecMassStat",
        "addedEP": "106",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "CO",
        "id": "126",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": ""
    },
    "CQ": {
        "name": "AccountSummaryReport",
        "abbrName": "AcctSumRpt",
        "updated": "FIX.5.0SP2",
        "addedEP": "117",
        "added": "FIX.5.0SP2",
        "updatedEP": "162",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "117",
            "FIXMLFileName": "accountreporting",
            "added": "FIX.5.0SP2",
            "name": "AccountReporting",
            "description": "Account Reporting"
        },
        "msgType": "CQ",
        "id": "127",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "117",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "117",
                "id": "715",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "name": "ClearingBusinessDate",
                    "abbrName": "BizDt",
                    "updated": "FIX.5.0SP2",
                    "added": "FIX.4.4",
                    "updatedEP": "150",
                    "id": "715",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "117",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "117",
                "id": "1699",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AccountSummaryReportID",
                    "abbrName": "RptID",
                    "addedEP": "117",
                    "added": "FIX.5.0SP2",
                    "id": "1699",
                    "description": "Unique identifier for the AccountSummaryReport(35=CQ)."
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The AccountSummaryReport is provided by the clearinghouse to its clearing members on a daily basis. It contains margin, settlement, collateral and pay/collect data for each clearing member level account type. Clearing member account types will be described through use of the Parties component and PtysSubGrp sub-component.\n\nIn certain usages, the clearing members can send the AccountSummaryReport message to the clearinghouse as needed. For example, clearing members can send this message to the clearinghouse to identify the value of collateral for each customer (to satisfy CFTC Legally Segregated Operationally Commingled (LSOC) regulatory reporting obligations).\n\nClearing organizations can also send the AccountSummaryReport message to regulators to meet regulatory reporting obligations. For example, clearing organizations can use this message to submit daily reports for each clearing member (“CM”) by house origin and by each customer origin for all futures, options, and swaps positions, and all securities positions held in a segregated account or pursuant to a cross margining agreement, to a regulator (e.g. to the CFTC to meet Part 39, Section 39.19 reporting obligations).\n\nThe Parties component and PtysSubGrp sub-component are used to describe the clearing member number and account type for that report. Net settlement amount or amounts are provided using the SettlementAmountGrp component. Margin requirement amounts are provided using the MarginAmountData component.\n\nThe current collateral values for each valid collateral type is provided using the CollateralAmountGrp component. Likewise pay/collect information is provided using the PayCollectGrp component. Margin and pay/collect amounts can optionally be tied to markets and market segments for clearing houses that support multiple markets and market segments."
    },
    "CR": {
        "name": "PartyRiskLimitsUpdateReport",
        "abbrName": "PtyRiskLmtUpd",
        "updated": "FIX.5.0SP2",
        "addedEP": "128",
        "added": "FIX.5.0SP2",
        "updatedEP": "195",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CR",
        "id": "128",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1667",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "RiskLimitReportID",
                    "abbrName": "RptID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1667",
                    "description": "Identifier for the PartyRiskLimitsReport"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyRiskLimitsUpdateReport(35=CR) is used to convey incremental changes to risk limits. It is similar to the regular report but uses the PartyRiskLimitsUpdateGrp component instead of the PartyRiskLimitsGrp component to include an update action."
    },
    "CS": {
        "name": "PartyRiskLimitsDefinitionRequest",
        "abbrName": "PtyRiskLmtDefReq",
        "addedEP": "128",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CS",
        "id": "129",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1666",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "RiskLimitRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1666",
                    "description": "Unique identifier for the PartyRiskLimitsRequest"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitDefinitionRequest is used for defining new risk limits."
    },
    "CT": {
        "name": "PartyRiskLimitsDefinitionRequestAck",
        "abbrName": "PtyRiskLmtDefReqAck",
        "addedEP": "128",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CT",
        "id": "130",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1666",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "RiskLimitRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1666",
                    "description": "Unique identifier for the PartyRiskLimitsRequest"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1762",
                "presence": "required",
                "data": {
                    "type": "PartyDetailRequestStatusCodeSet",
                    "name": "RiskLimitRequestStatus",
                    "abbrName": "ReqStat",
                    "updated": "FIX.5.0SP2",
                    "addedEP": "128",
                    "added": "FIX.5.0SP2",
                    "updatedEP": "146",
                    "id": "1762",
                    "description": "Status of risk limit definition request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitDefinitionRequestAck is used for accepting (with or without changes) or rejecting the definition of risk limits."
    },
    "CU": {
        "name": "PartyEntitlementsRequest",
        "abbrName": "PtyEntlmntReq",
        "addedEP": "129",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CU",
        "id": "131",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsRequest message is used to request for entitlement information for one or more party(-ies), specific party role(s), or specific instruments(s)."
    },
    "CV": {
        "name": "PartyEntitlementsReport",
        "abbrName": "PtyEntlmntRpt",
        "addedEP": "129",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CV",
        "id": "132",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "id": "1771",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "EntitlementReportID",
                    "abbrName": "RptID",
                    "addedEP": "129",
                    "added": "FIX.5.0SP2",
                    "id": "1771",
                    "description": "Identifier for the PartyEntitlementsReport(35=CV)."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsReport is used to report entitlements for one or more parties, party role(s), or specific instrument(s)."
    },
    "CW": {
        "name": "QuoteAck",
        "abbrName": "QuotAck",
        "addedEP": "143",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "quotation",
            "name": "QuotationNegotiation"
        },
        "msgType": "CW",
        "id": "133",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "143",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "143",
                "id": "1865",
                "presence": "required",
                "data": {
                    "type": "QuoteAckStatusCodeSet",
                    "name": "QuoteAckStatus",
                    "abbrName": "QtAckStat",
                    "addedEP": "143",
                    "added": "FIX.5.0SP2",
                    "id": "1865",
                    "description": "Acknowledgement status of a Quote(35=S) or QuoteCancel(35=Z) message submission."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "143",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The QuoteAck(35=CW) message is used to acknowledge a Quote(35=S) submittal or request to cancel an individual quote using the QuoteCancel(35=Z) message during a Quote/Negotiation dialog.\n\nThe QuoteAck(35=CW) is available for optional use to acknowledge the request to cancel an individual quote (QuoteCancel(35=Z) with QuoteCancelType(298) =5(Cancel specified sinqle quote))."
    },
    "CX": {
        "name": "PartyDetailsDefinitionRequest",
        "abbrName": "PtyDetlDefReq",
        "addedEP": "146",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CX",
        "id": "134",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1505",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PartyDetailsListRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1505",
                    "description": "Unique identifier for PartyDetailsListRequest."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "2182",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "PartyDetailsUpdateGrp",
                    "abbrName": "PtyDetlUpd",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "category": "PartiesReferenceData",
                    "id": "2182",
                    "numInGroup": { "id": "1676", "added": "FIX.5.0SP2", "addedEP": "105" },
                    "description": "Party details component that includes an update action.\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsDefinitionRequest(35=CX) is used for defining new parties and modifying or deleting existing parties information, including the relationships between parties.\n\nThe recipient of the message responds with a PartyDetailsDefinitionRequestAck(35=CY) to indicate whether the request was accepted or rejected."
    },
    "CY": {
        "name": "PartyDetailsDefinitionRequestAck",
        "abbrName": "PtyDetlDefReqAck",
        "addedEP": "146",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CY",
        "id": "135",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1505",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PartyDetailsListRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1505",
                    "description": "Unique identifier for PartyDetailsListRequest."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1878",
                "presence": "required",
                "data": {
                    "type": "PartyDetailRequestStatusCodeSet",
                    "name": "PartyDetailRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "146",
                    "added": "FIX.5.0SP2",
                    "id": "1878",
                    "description": "Status of party details definition request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsDefinitionRequestAck(35=CY) is used as a response to the PartyDetailsDefinitionRequest(35=CX) message. The request can be accepted (with or without changes) or rejected."
    },
    "CZ": {
        "name": "PartyEntitlementsUpdateReport",
        "abbrName": "PtyEntlmntUpd",
        "updated": "FIX.5.0SP2",
        "addedEP": "146",
        "added": "FIX.5.0SP2",
        "updatedEP": "195",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "CZ",
        "id": "136",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1771",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "EntitlementReportID",
                    "abbrName": "RptID",
                    "addedEP": "129",
                    "added": "FIX.5.0SP2",
                    "id": "1771",
                    "description": "Identifier for the PartyEntitlementsReport(35=CV)."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "2215",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "PartyEntitlementUpdateGrp",
                    "abbrName": "PtyEntlmntUpd",
                    "addedEP": "146",
                    "added": "FIX.5.0SP2",
                    "category": "PartiesReferenceData",
                    "id": "2215",
                    "numInGroup": { "id": "1772", "added": "FIX.5.0SP2", "addedEP": "146" },
                    "description": "The PartyEntitlementUpdateGrp component is used to supply incremental entitlement definitions changes for the party(-ies) specified in the PartyDetailGrp component. The update action type is specified using ListUpdateAction(1324).\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsUpdateReport(35=CZ) is used to convey incremental changes to party entitlements. It is similar to the PartyEntitlementsReport(35=CV). This message uses the PartyEntitlementsUpdateGrp component which includes the ability to specify an update action using ListUpdateAction(1324)."
    },
    "DA": {
        "name": "PartyEntitlementsDefinitionRequest",
        "abbrName": "PtyEntlmntDefReq",
        "addedEP": "146",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "DA",
        "id": "137",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1770",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "EntitlementRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "129",
                    "added": "FIX.5.0SP2",
                    "id": "1770",
                    "description": "Unique identifier for PartyEntitlementsRequest(35=CU)."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "2215",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "PartyEntitlementUpdateGrp",
                    "abbrName": "PtyEntlmntUpd",
                    "addedEP": "146",
                    "added": "FIX.5.0SP2",
                    "category": "PartiesReferenceData",
                    "id": "2215",
                    "numInGroup": { "id": "1772", "added": "FIX.5.0SP2", "addedEP": "146" },
                    "description": "The PartyEntitlementUpdateGrp component is used to supply incremental entitlement definitions changes for the party(-ies) specified in the PartyDetailGrp component. The update action type is specified using ListUpdateAction(1324).\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsDefinitionRequest(35=DA) is used for defining new entitlements, and modifying or deleting existing entitlements for the specified party(-ies).\n\nThe PartyEntitlementsDefinitionRequestAck(35=DB) is the response message, used to indicate whether the request was accepted or rejected."
    },
    "DB": {
        "name": "PartyEntitlementsDefinitionRequestAck",
        "abbrName": "PtyEntlmntDefReqAck",
        "addedEP": "146",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "DB",
        "id": "138",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1770",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "EntitlementRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "129",
                    "added": "FIX.5.0SP2",
                    "id": "1770",
                    "description": "Unique identifier for PartyEntitlementsRequest(35=CU)."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1882",
                "presence": "required",
                "data": {
                    "type": "PartyDetailRequestStatusCodeSet",
                    "name": "EntitlementRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "146",
                    "added": "FIX.5.0SP2",
                    "id": "1882",
                    "description": "Status of party entitlements definition request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsDefinitionRequestAck(35=DB) is used as a response to the PartyEntitlemensDefinitionRequest(35=DA) to accept (with or without changes) or reject the definition of party entitlements."
    },
    "DC": {
        "name": "TradeMatchReport",
        "abbrName": "TrdMtchRpt",
        "addedEP": "150",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "tradecapture",
            "name": "TradeCapture"
        },
        "msgType": "DC",
        "id": "139",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "id": "880",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TrdMatchID",
                    "abbrName": "MtchID",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.4",
                    "updatedEP": "279",
                    "id": "880",
                    "description": "Identifier assigned by a matching system to a match event that results in multiple executions or trades."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The TradeMatchReport(35=DC) message is used by exchanges and ECN’s to report matched trades to central counterparties (CCPs) as an atomic event. The message is used to express the one-to-one, one-to-many and many-to-many matches as well as implied matches in which more complex instruments can match with simpler instruments."
    },
    "DD": {
        "name": "TradeMatchReportAck",
        "abbrName": "TrdMtchRptAck",
        "addedEP": "150",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "tradecapture",
            "name": "TradeCapture"
        },
        "msgType": "DD",
        "id": "140",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "id": "880",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TrdMatchID",
                    "abbrName": "MtchID",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.4",
                    "updatedEP": "279",
                    "id": "880",
                    "description": "Identifier assigned by a matching system to a match event that results in multiple executions or trades."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "id": "1896",
                "presence": "required",
                "data": {
                    "type": "TradeMatchAckStatusCodeSet",
                    "name": "TradeMatchAckStatus",
                    "abbrName": "MtchAckStat",
                    "addedEP": "150",
                    "added": "FIX.5.0SP2",
                    "id": "1896",
                    "description": "Used to indicate the status of the trade match report submission."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The TradeMatchReportAck(35=DD) is used to respond to theTradeMatchReport(35=DC) message. It may be used to report on the status of the request (e.g. accepting the request or rejecting the request)."
    },
    "DE": {
        "name": "PartyRiskLimitsReportAck",
        "abbrName": "PtyRiskLmtRptAck",
        "addedEP": "171",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "FIXMLFileName": "partiesreference",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "msgType": "DE",
        "id": "141",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1667",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "RiskLimitReportID",
                    "abbrName": "RptID",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "id": "1667",
                    "description": "Identifier for the PartyRiskLimitsReport"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2316",
                "presence": "required",
                "data": {
                    "type": "RiskLimitReportStatusCodeSet",
                    "name": "RiskLimitReportStatus",
                    "abbrName": "RptStat",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2316",
                    "description": "Status of risk limit report."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitsReportAck is an optional message used as a response to the PartyRiskLimitReport(35=CM) or PartyRiskLimitUpdateReport(35=CR) messages to acknowledge or reject those messages."
    },
    "DF": {
        "name": "PartyRiskLimitCheckRequest",
        "abbrName": "PtyRiskLmtChkReq",
        "addedEP": "171",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "171",
            "FIXMLFileName": "partiesaction",
            "added": "FIX.5.0SP2",
            "name": "PartiesAction",
            "description": "The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day."
        },
        "msgType": "DF",
        "id": "142",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2320",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckTransTypeCodeSet",
                    "name": "RiskLimitCheckTransType",
                    "abbrName": "TransTyp",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2320",
                    "description": "Specifies the transaction type of the risk limit check request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2321",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckTypeCodeSet",
                    "name": "RiskLimitCheckType",
                    "abbrName": "ChkTyp",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2321",
                    "description": "Specifies the type of limit check message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitCheckRequest is used to request for approval of credit or risk limit amount intended to be used by a party in a transaction from another party that holds the information."
    },
    "DG": {
        "name": "PartyRiskLimitCheckRequestAck",
        "abbrName": "PtyRiskLmtChkReqAck",
        "addedEP": "171",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "171",
            "FIXMLFileName": "partiesaction",
            "added": "FIX.5.0SP2",
            "name": "PartiesAction",
            "description": "The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day."
        },
        "msgType": "DG",
        "id": "143",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2320",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckTransTypeCodeSet",
                    "name": "RiskLimitCheckTransType",
                    "abbrName": "TransTyp",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2320",
                    "description": "Specifies the transaction type of the risk limit check request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2321",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckTypeCodeSet",
                    "name": "RiskLimitCheckType",
                    "abbrName": "ChkTyp",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2321",
                    "description": "Specifies the type of limit check message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2325",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckRequestStatusCodeSet",
                    "name": "RiskLimitCheckRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2325",
                    "description": "Indicates the status of the risk limit check request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitCheckRequestAck is used to acknowledge a PartyRiskLimitCheckRequest(35=DF) message and to respond whether the limit check request was approved or not. When used to accept the PartyRiskLimitCheckRequest(35=DF) message the Respondent may also include the limit amount that was approved."
    },
    "DH": {
        "name": "PartyActionRequest",
        "abbrName": "PtyActReq",
        "updated": "FIX.5.0SP2",
        "addedEP": "171",
        "added": "FIX.5.0SP2",
        "updatedEP": "182",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "171",
            "FIXMLFileName": "partiesaction",
            "added": "FIX.5.0SP2",
            "name": "PartiesAction",
            "description": "The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day."
        },
        "msgType": "DH",
        "id": "144",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "171",
                "added": "FIX.5.0SP2",
                "updatedEP": "182",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2328",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PartyActionRequestID",
                    "abbrName": "ActnReqID",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2328",
                    "description": "The unique identifier of the PartyActionRequest(35=DH) message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2329",
                "presence": "required",
                "data": {
                    "type": "PartyActionTypeCodeSet",
                    "name": "PartyActionType",
                    "abbrName": "ActnTyp",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2329",
                    "description": "Specifies the type of action to take or was taken for a given party."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyActionRequest message is used suspend or halt the specified party from further trading activities at the Respondent. The Respondent must respond with a PartyActionReport(35=DI) message."
    },
    "DI": {
        "name": "PartyActionReport",
        "abbrName": "PtyActRpt",
        "updated": "FIX.5.0SP2",
        "addedEP": "171",
        "added": "FIX.5.0SP2",
        "updatedEP": "182",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "171",
            "FIXMLFileName": "partiesaction",
            "added": "FIX.5.0SP2",
            "name": "PartiesAction",
            "description": "The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day."
        },
        "msgType": "DI",
        "id": "145",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "171",
                "added": "FIX.5.0SP2",
                "updatedEP": "182",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2329",
                "presence": "required",
                "data": {
                    "type": "PartyActionTypeCodeSet",
                    "name": "PartyActionType",
                    "abbrName": "ActnTyp",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2329",
                    "description": "Specifies the type of action to take or was taken for a given party."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2331",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PartyActionReportID",
                    "abbrName": "ActnRptID",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2331",
                    "description": "The unique identifier of the PartyActionReport(35=DI) message as assigned by the message sender."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "2332",
                "presence": "required",
                "data": {
                    "type": "PartyActionResponseCodeSet",
                    "name": "PartyActionResponse",
                    "abbrName": "ActnRsp",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "id": "2332",
                    "description": "Specifies the action taken as a result of the PartyActionType(2239) of the PartyActionRequest(35=DH) message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Used to respond to the PartyActionRequest(35=DH) message, indicating whether the request has been received, accepted or rejected. Can also be used in an unsolicited manner to report party actions, e.g. reinstatements after a manual intervention out of band."
    },
    "DJ": {
        "name": "MassOrder",
        "abbrName": "MassOrder",
        "addedEP": "188",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "ordermasshandling",
            "name": "OrderMassHandling"
        },
        "msgType": "DJ",
        "id": "146",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "id": "2245",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "OrderEntryGrp",
                    "abbrName": "OrderEntry",
                    "addedEP": "188",
                    "added": "FIX.5.0SP2",
                    "category": "OrderMassHandling",
                    "id": "2245",
                    "numInGroup": { "id": "2428", "added": "FIX.5.0SP2", "addedEP": "188" },
                    "description": "Group of order transactions across one or more instruments.\n\n"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "188",
                "added": "FIX.5.0SP2",
                "updatedEP": "271",
                "id": "2423",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MassOrderRequestID",
                    "abbrName": "MassOrdReqID",
                    "addedEP": "188",
                    "added": "FIX.5.0SP2",
                    "id": "2423",
                    "description": "Unique message identifier for a mass order request as assigned by the submitter of the orders."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The MassOrder(35=DJ) message can be used to add, modify or delete multiple unrelated orders with a single message. Apart from clearing related attributes, only the key order attributes for high performance trading are available.\n\nThe behavior of individual orders within a MassOrder(35=DJ) may vary depending upon its attributes, e.g. OrdType(40) and TimeInForce(59). Individual orders may be modified or deleted/cancelled with single order messages such as OrderCancelReplaceRequest (35=G) and OrderCancelRequest(35=F). Each of the orders in the MassOrder(35=DJ) are to be treated as stand-alone individual orders."
    },
    "DK": {
        "name": "MassOrderAck",
        "abbrName": "MassOrderAck",
        "addedEP": "188",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "ordermasshandling",
            "name": "OrderMassHandling"
        },
        "msgType": "DK",
        "id": "147",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "id": "1815",
                "presence": "required",
                "data": {
                    "type": "TradingCapacityCodeSet",
                    "name": "TradingCapacity",
                    "abbrName": "TrdgCpcty",
                    "addedEP": "131",
                    "added": "FIX.5.0SP2",
                    "id": "1815",
                    "description": "Designates the capacity in which the order is submitted for trading by the market participant."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "id": "2425",
                "presence": "required",
                "data": {
                    "type": "MassOrderRequestStatusCodeSet",
                    "name": "MassOrderRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "188",
                    "added": "FIX.5.0SP2",
                    "id": "2425",
                    "description": "Status of mass order request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "2",
            "name": "Trade",
            "FIXMLFileName": "trade",
            "description": "Order handling and execution messages"
        },
        "description": "The mass order acknowledgement message is used to acknowledge the receipt of and the status for a MassOrder(35=DJ) message.\n\nThe content of the acknowledgement depends on the setting of the field OrderResponseLevel(2427) in the MassOrder(35=DJ) message. Only the order status is provided and not the immediate executions which would lead to ExecutionReport messages."
    },
    "DL": {
        "name": "PositionTransferInstruction",
        "abbrName": "PosXferInstrctn",
        "addedEP": "189",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "DL",
        "id": "148",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "189",
                "added": "FIX.5.0SP2",
                "updatedEP": "271",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "1063",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "TargetParties",
                    "abbrName": "TgtPty",
                    "addedEP": "85",
                    "added": "FIX.5.0SP1",
                    "category": "Common",
                    "id": "1063",
                    "numInGroup": { "id": "1461", "added": "FIX.5.0SP1", "addedEP": "85" },
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "2436",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TransferInstructionID",
                    "abbrName": "InstID",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "id": "2436",
                    "description": "Unique identifier for the transfer instruction assigned by the submitter."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The PositionTransferInstruction(35=DL) is sent by clearing firms to CCPs to initiate position transfers, or to accept or decline position transfers."
    },
    "DM": {
        "name": "PositionTransferInstructionAck",
        "abbrName": "PosXferInstrctnAck",
        "addedEP": "189",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "DM",
        "id": "149",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "2436",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TransferInstructionID",
                    "abbrName": "InstID",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "id": "2436",
                    "description": "Unique identifier for the transfer instruction assigned by the submitter."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The PositionTransferInstructionAck(35=DM) is sent by CCPs to clearing firms to acknowledge position transfer instructions, and to report errors processing position transfer instructions.\n\nThe PositionTransferInstructionAck(35=DM) is intended to be a technical acknowledgment, not a business level acknowledgment which would instead be provided by the PositionTransferReport(35=DN) message. As such, TransferID(2437), a business level ID assigned by the CCP, need not be assigned when providing a technical acknowledgment to a new or rejected position transfer request."
    },
    "DN": {
        "name": "PositionTransferReport",
        "abbrName": "PosXferRpt",
        "addedEP": "189",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "positions",
            "name": "PositionMaintenance"
        },
        "msgType": "DN",
        "id": "150",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "189",
                "added": "FIX.5.0SP2",
                "updatedEP": "271",
                "id": "1063",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "TargetParties",
                    "abbrName": "TgtPty",
                    "addedEP": "85",
                    "added": "FIX.5.0SP1",
                    "category": "Common",
                    "id": "1063",
                    "numInGroup": { "id": "1461", "added": "FIX.5.0SP1", "addedEP": "85" },
                    "description": "\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "2437",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TransferID",
                    "abbrName": "XferID",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "id": "2437",
                    "description": "The unique identifier assigned to the transfer entity once it is received, for example, by the CCP or the party governing the transfer process. Generally this same identifier for the transfer is used by all parties involved."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "2438",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TransferReportID",
                    "abbrName": "RptID",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "id": "2438",
                    "description": "Unique identifier for the transfer report message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "2439",
                "presence": "required",
                "data": {
                    "type": "TransferTransTypeCodeSet",
                    "name": "TransferTransType",
                    "abbrName": "TransTyp",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "id": "2439",
                    "description": "Indicates the type of transfer transaction."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "2442",
                "presence": "required",
                "data": {
                    "type": "TransferStatusCodeSet",
                    "name": "TransferStatus",
                    "abbrName": "XferStat",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "id": "2442",
                    "description": "Status of the transfer."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "id": "2444",
                "presence": "required",
                "data": {
                    "type": "TransferReportTypeCodeSet",
                    "name": "TransferReportType",
                    "abbrName": "RptTyp",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "id": "2444",
                    "description": "Indicates the type of transfer report."
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The PositionTransferReport(35=DN) is sent by CCPs to clearing firms indicating of positions that are to be transferred to the clearing firm, or to report on status of the transfer to the clearing firms involved in the transfer process."
    },
    "DO": {
        "name": "MarketDataStatisticsRequest",
        "abbrName": "MDStatsReq",
        "addedEP": "191",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "DO",
        "id": "151",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "id": "263",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "name": "SubscriptionRequestType",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "191",
                "added": "FIX.5.0SP2",
                "updatedEP": "271",
                "id": "2248",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "MDStatisticReqGrp",
                    "abbrName": "StatsReq",
                    "addedEP": "191",
                    "added": "FIX.5.0SP2",
                    "category": "MarketData",
                    "id": "2248",
                    "numInGroup": { "id": "2474", "added": "FIX.5.0SP2", "addedEP": "191" },
                    "description": "This component block is used within the MarketDataStatisticsRequest(35=DO) message to define a set of parameters describing the desired statistics.\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "id": "2452",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MDStatisticReqID",
                    "abbrName": "ReqID",
                    "addedEP": "191",
                    "added": "FIX.5.0SP2",
                    "id": "2452",
                    "description": "Message identifier for a statistics request."
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The MarketDataStatisticsRequest(35=DO) is used to request for statistical data. The simple form is to use an identifier (MDStatisticID(2475)) assigned by the market place which would denote a pre-defined statistical report. Alternatively, or also in addition, the request can define a number of parameters for the desired statistical information.\n\nThe resulting data set can be restricted to a specific market, market segment or pre-defined security list for which a single set of statistics will be returned. It is also possible to specify individual instruments or group of instruments by means of the component blocks Instrument, UndInstrmtGrp and InstrmtLegGrp.\n\nFields specified in the request are used as filter criteria to restrict the resulting data returned."
    },
    "DP": {
        "name": "MarketDataStatisticsReport",
        "abbrName": "MDStatsRpt",
        "addedEP": "191",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "DP",
        "id": "152",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "id": "2249",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "MDStatisticRptGrp",
                    "abbrName": "StatsRpt",
                    "addedEP": "191",
                    "added": "FIX.5.0SP2",
                    "category": "MarketData",
                    "id": "2249",
                    "numInGroup": { "id": "2474", "added": "FIX.5.0SP2", "addedEP": "191" },
                    "description": "This component block is used within the MarketDataStatisticsReport(35=DP) message to provide results together with the related set of parameters.\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "id": "2453",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "MDStatisticRptID",
                    "abbrName": "RptID",
                    "addedEP": "191",
                    "added": "FIX.5.0SP2",
                    "id": "2453",
                    "description": "Message identifier for a statistics report."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The MarketDataStatisticsReport(35=DP) is used to provide unsolicited statistical information or in response to a specific request. Each report contains a set of statistics for a single entity which could be a market, a market segment, a security list or an instrument.\n\n"
    },
    "DQ": {
        "name": "CollateralReportAck",
        "abbrName": "CollRptAck",
        "addedEP": "192",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "collateral",
            "name": "CollateralManagement"
        },
        "msgType": "DQ",
        "id": "153",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "192",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "192",
                "id": "908",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CollRptID",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "id": "908",
                    "description": "Collateral Report Identifier"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "192",
                "id": "2488",
                "presence": "required",
                "data": {
                    "type": "CollRptStatusCodeSet",
                    "name": "CollRptStatus",
                    "abbrName": "RptStat",
                    "addedEP": "192",
                    "added": "FIX.5.0SP2",
                    "id": "2488",
                    "description": "The status of the collateral report."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "192",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "CollateralReportAck(35=DQ) is used as a response to the CollateralReport(35=BA). It can be used to reject a CollateralReport(35=BA) when the content of the report is invalid based on the business rules of the receiver. The message may also be used to acknowledge receipt of a valid CollateralReport(35=BA)."
    },
    "DR": {
        "name": "MarketDataReport",
        "abbrName": "MktDataRpt",
        "addedEP": "195",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "marketdata",
            "name": "MarketData"
        },
        "msgType": "DR",
        "id": "154",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "195",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "195",
                "id": "2535",
                "presence": "required",
                "data": {
                    "type": "MDReportEventCodeSet",
                    "name": "MDReportEvent",
                    "abbrName": "MDRptEvent",
                    "addedEP": "195",
                    "added": "FIX.5.0SP2",
                    "id": "2535",
                    "description": "Technical event within market data feed."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "195",
                "id": "2536",
                "presence": "required",
                "data": {
                    "type": "int",
                    "name": "MDReportCount",
                    "abbrName": "MDRptCnt",
                    "addedEP": "195",
                    "added": "FIX.5.0SP2",
                    "id": "2536",
                    "description": "Number of reference and market data messages in-between two MarketDataReport(35=DR) messages."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "195",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The MarketDataReport(35=DR) message is used to provide delimiting references (e.g. start and end markers in a continuous broadcast) and details about the number of market data messages sent in a given distribution cycle.\n\nThe message can be used when distributing reference and market data on an ongoing basis to convey start and end points for synchronization. The report contains multiple message counters that are provided at the beginning or end of a cycle."
    },
    "DS": {
        "name": "CrossRequest",
        "abbrName": "CrssReq",
        "addedEP": "223",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "indications",
            "name": "Indication"
        },
        "msgType": "DS",
        "id": "155",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "id": "2672",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CrossRequestID",
                    "abbrName": "CrssReqID",
                    "addedEP": "223",
                    "added": "FIX.5.0SP2",
                    "id": "2672",
                    "description": "Unique message identifier for a cross request as assigned by the submitter of the request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The CrossRequest(35=DS) message is used to indicate the submission of orders or quotes that may result in a crossed trade.\n\nRegulatory requirements can allow exchanges to match orders belonging to the same account, firm or other common attribute. This can include the requirement to first announce the intention to cross orders. The time permitted between the announcement and the actual cross is typically well defined and may depend on the maximum quantity announced."
    },
    "DT": {
        "name": "CrossRequestAck",
        "abbrName": "CrssReqAck",
        "addedEP": "223",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "indications",
            "name": "Indication"
        },
        "msgType": "DT",
        "id": "156",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "id": "2672",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "CrossRequestID",
                    "abbrName": "CrssReqID",
                    "addedEP": "223",
                    "added": "FIX.5.0SP2",
                    "id": "2672",
                    "description": "Unique message identifier for a cross request as assigned by the submitter of the request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The CrossRequestAck(35=DT) message is used to confirm the receipt of a CrossRequest(35=DS) message."
    },
    "DU": {
        "name": "AllocationInstructionAlertRequest",
        "abbrName": "AllocInstrAlertReq",
        "addedEP": "239",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "allocation",
            "name": "Allocation"
        },
        "msgType": "DU",
        "id": "157",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "239",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "239",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "This message is used in a clearinghouse 3-party allocation model to request for AllocationInstructionAlert(35=BM) from the clearinghouse. The request may be used to obtain a one-time notification of the status of an allocation group."
    },
    "DV": {
        "name": "AllocationInstructionAlertRequestAck",
        "abbrName": "AllocInstrctnAlertReqAck",
        "addedEP": "241",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "FIXMLFileName": "allocation",
            "name": "Allocation"
        },
        "msgType": "DV",
        "id": "158",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "241",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "241",
                "id": "2758",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AllocRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "239",
                    "added": "FIX.5.0SP2",
                    "id": "2758",
                    "description": "Unique identifier for the request message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "241",
                "id": "2768",
                "presence": "required",
                "data": {
                    "type": "AllocRequestStatusCodeSet",
                    "name": "AllocRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "241",
                    "added": "FIX.5.0SP2",
                    "id": "2768",
                    "description": "Status of the AllocationInstructionAlertRequest(35=DU)."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "241",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "This message is used in a clearinghouse 3-party allocation model to acknowledge a AllocationInstructionAlertRequest(35=DU) message for an AllocationInstructionAlert(35=BM) message from the clearinghouse."
    },
    "DW": {
        "name": "TradeAggregationRequest",
        "abbrName": "TrdAggrtnReq",
        "addedEP": "247",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "247",
            "FIXMLFileName": "trademanagement",
            "added": "FIX.5.0SP2",
            "name": "TradeManagement"
        },
        "msgType": "DW",
        "id": "159",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "54",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "name": "Side",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "2786",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TradeAggregationRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "247",
                    "added": "FIX.5.0SP2",
                    "id": "2786",
                    "description": "The message identifier for the trade aggregation request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "2788",
                "presence": "required",
                "data": {
                    "type": "TradeAggregationTransTypeCodeSet",
                    "name": "TradeAggregationTransType",
                    "abbrName": "TransTyp",
                    "addedEP": "247",
                    "added": "FIX.5.0SP2",
                    "id": "2788",
                    "description": "Identifies the trade aggregation transaction type."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "1003",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "Instrument",
                    "abbrName": "Instrmt",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1003",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "TradeAggregationRequest(35=DW) is used to request that the identified trades between the initiator and respondent be aggregated together for further processing."
    },
    "DX": {
        "name": "TradeAggregationReport",
        "abbrName": "TrdAggrtnRpt",
        "addedEP": "247",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "247",
            "FIXMLFileName": "trademanagement",
            "added": "FIX.5.0SP2",
            "name": "TradeManagement"
        },
        "msgType": "DX",
        "id": "160",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "2790",
                "presence": "required",
                "data": {
                    "type": "TradeAggregationRequestStatusCodeSet",
                    "name": "TradeAggregationRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "247",
                    "added": "FIX.5.0SP2",
                    "id": "2790",
                    "description": "Status of the trade aggregation request."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "2792",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TradeAggregationReportID",
                    "abbrName": "RptID",
                    "addedEP": "247",
                    "added": "FIX.5.0SP2",
                    "id": "2792",
                    "description": "Unique identifier for the TradeAggregationReport(35=DX)."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "TradeAggregationReport(35=DX) is used to respond to the TradeAggregationRequest(35=DW) message. It provides the status of the request (e.g. accepted or rejected) and may also provide additional information supplied by the respondent."
    },
    "EA": {
        "name": "PayManagementReport",
        "abbrName": "PayMgmtRpt",
        "addedEP": "249",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "249",
            "FIXMLFileName": "paymgt",
            "added": "FIX.5.0SP2",
            "name": "PayManagement",
            "description": "Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks."
        },
        "msgType": "EA",
        "id": "161",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2799",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PayReportID",
                    "abbrName": "RptID",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "id": "2799",
                    "description": "Unique ID of the PayManagementReport(35=EA) message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2804",
                "presence": "required",
                "data": {
                    "type": "PayReportTransTypeCodeSet",
                    "name": "PayReportTransType",
                    "abbrName": "TxnTyp",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "id": "2804",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2265",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "PostTradePayment",
                    "abbrName": "PostTrdPmt",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "category": "PayManagement",
                    "id": "2265",
                    "fieldRef": [
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2824",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentType"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2817",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentAmount"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2825",
                            "presence": "required",
                            "description": "The date payment calculations are made. This may be earlier than the date in ClearingBusinessDate(715).\n\nWhen the report is sent unsolicited, this is the payment calculation date as determined by report sender.",
                            "name": "PostTradePaymentCalculationDate"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2826",
                            "presence": "required",
                            "description": "The date the payment is legally confirmed to settle.",
                            "name": "PostTradePaymentValueDate"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2819",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentDebitOrCredit"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2816",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentAccount"
                        }
                    ],
                    "description": "This component specifies the details of a payment between the parties involved.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "PayManagementReport(35=EA) may be used to respond to the PayManagementRequest(35=DY) message. It provides the status of the request (e.g. accepted, disputed) and may provide additional information related to the request.\n\nPayManagementReport(35=EA) may also be sent unsolicited by the broker to a client. In which case the client may acknowledge and resolve disputes out-of-band or with a simple PayManagementReportAck(35=EB).\n\nPayManagementReport(35=EA) may also be sent unsolicited to report the progress status of the payment itself with PayReportTransType(2804)=2 (Status).\n\nIt should be noted that this message, in the context of operational communication between investment managers and their brokers, is intended to agree and confirm on payment(s) to be made or received during the life of a contract."
    },
    "EB": {
        "name": "PayManagementReportAck",
        "abbrName": "PayMgmtRptAck",
        "addedEP": "249",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "249",
            "FIXMLFileName": "paymgt",
            "added": "FIX.5.0SP2",
            "name": "PayManagement",
            "description": "Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks."
        },
        "msgType": "EB",
        "id": "162",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2799",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PayReportID",
                    "abbrName": "RptID",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "id": "2799",
                    "description": "Unique ID of the PayManagementReport(35=EA) message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2806",
                "presence": "required",
                "data": {
                    "type": "PayReportStatusCodeSet",
                    "name": "PayReportStatus",
                    "abbrName": "RptStat",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "id": "2806",
                    "description": "Identifies status of the payment report."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "PayManagementReportAck(35=EB) is used as a response to the PayManagementReport(35=EA) message. It may be used to accept, reject or dispute the details of the PayManagementReport(35=EA) depending on the business rules of the receiver. This message may also be used to acknowledge the receipt of a PayManagementReport(35=EA) message."
    },
    "DY": {
        "name": "PayManagementRequest",
        "abbrName": "PayMgmtReq",
        "addedEP": "249",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "249",
            "FIXMLFileName": "paymgt",
            "added": "FIX.5.0SP2",
            "name": "PayManagement",
            "description": "Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks."
        },
        "msgType": "DY",
        "id": "163",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2811",
                "presence": "required",
                "data": {
                    "type": "PayRequestTransTypeCodeSet",
                    "name": "PayRequestTransType",
                    "abbrName": "TxnTyp",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "id": "2811",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2812",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PayRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "id": "2812",
                    "description": "Unique ID of the PayManagementRequest(35=DY) message."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2265",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "PostTradePayment",
                    "abbrName": "PostTrdPmt",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "category": "PayManagement",
                    "id": "2265",
                    "fieldRef": [
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2824",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentType"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2817",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentAmount"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2825",
                            "presence": "required",
                            "description": "The date payment calculations are made. This may be earlier than the date in ClearingBusinessDate(715).\n\nWhen the report is sent unsolicited, this is the payment calculation date as determined by report sender.",
                            "name": "PostTradePaymentCalculationDate"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2826",
                            "presence": "required",
                            "description": "The date the payment is legally confirmed to settle.",
                            "name": "PostTradePaymentValueDate"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2819",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentDebitOrCredit"
                        },
                        {
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "id": "2816",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentAccount"
                        }
                    ],
                    "description": "This component specifies the details of a payment between the parties involved.\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "PayManagementRequest(35=DY) message is used to communicate a future or expected payment to be made or received related to a trade or contract after its settlement.\n\nIt should be noted that this message, in the context of operational communication between investment managers and their brokers, is intended to agree and confirm on payment(s) to be made or received during the life of a contract."
    },
    "DZ": {
        "name": "PayManagementRequestAck",
        "abbrName": "PayMgmtReqAck",
        "addedEP": "249",
        "added": "FIX.5.0SP2",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "249",
            "FIXMLFileName": "paymgt",
            "added": "FIX.5.0SP2",
            "name": "PayManagement",
            "description": "Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks."
        },
        "msgType": "DZ",
        "id": "164",
        "structure": [
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "2812",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "PayRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "id": "2812",
                    "description": "Unique ID of the PayManagementRequest(35=DY) message."
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "249",
                "added": "FIX.5.0SP2",
                "updatedEP": "282",
                "id": "2813",
                "presence": "required",
                "data": {
                    "type": "PayRequestStatusCodeSet",
                    "name": "PayRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "id": "2813",
                    "description": "Identifies status of the request being responded to."
                }
            },
            {
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "PayManagementRequestAck(35=DZ) is used to acknowledge the receipt of the PayManagementRequest(35=DY) message (i.e. a technical acknowledgement of receipt). Acceptance or rejection of the request is reported in the corresponding PayManagementReport(35=EA)."
    },
    "EC": {
        "name": "SettlementStatusRequest",
        "abbrName": "SettlStatReq",
        "addedEP": "281",
        "added": "FIX.Latest",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "281",
            "FIXMLFileName": "settlstatmgmt",
            "added": "FIX.Latest",
            "name": "SettlementStatusManagement",
            "description": "Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process."
        },
        "msgType": "EC",
        "id": "165",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "263",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "name": "SubscriptionRequestType",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "2965",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SettlStatusRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "id": "2965",
                    "description": "Unique identifier of the SettlementStatusRequest(35=EC)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "SettlementStatusRequest(35=EC) is used to request for the settlement status of a trade.\n\nWhere possible a trade reference or identifier should be provided, and if it is not possible it is recommended that as much of the trade details are provided in the request as possible. The trade details provided are not intended to serve as filter criteria but look-up criteria."
    },
    "ED": {
        "name": "SettlementStatusRequestAck",
        "abbrName": "SettlStatReqAck",
        "addedEP": "281",
        "added": "FIX.Latest",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "281",
            "FIXMLFileName": "settlstatmgmt",
            "added": "FIX.Latest",
            "name": "SettlementStatusManagement",
            "description": "Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process."
        },
        "msgType": "ED",
        "id": "166",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "2965",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SettlStatusRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "id": "2965",
                    "description": "Unique identifier of the SettlementStatusRequest(35=EC)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "2966",
                "presence": "required",
                "data": {
                    "type": "SettlStatusRequestStatusCodeSet",
                    "name": "SettlStatusRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "id": "2966",
                    "description": "Status of the SettlementStatusRequest(35=EC) message being responded to."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "SettlementStatusRequestAck(35=ED) is used to respond to the SettlementStatusRequest(35=EC) to acknowledge the request and provide status for the request message.\n\nThis message is not used for communicating settlement status of a trade (see SettlementStatusReport(35=EE)); simply a status of the request message itself."
    },
    "EE": {
        "name": "SettlementStatusReport",
        "abbrName": "SettlStatRpt",
        "addedEP": "281",
        "added": "FIX.Latest",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "281",
            "FIXMLFileName": "settlstatmgmt",
            "added": "FIX.Latest",
            "name": "SettlementStatusManagement",
            "description": "Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process."
        },
        "msgType": "EE",
        "id": "167",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "2967",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SettlStatusReportID",
                    "abbrName": "RptID",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "id": "2967",
                    "description": "Unique identifier of the SettlementStatusReport(35=EE)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "2968",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SettlStatus",
                    "abbrName": "SettlStat",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "id": "2968",
                    "description": "The settlement status of the identified trade.\n\nThis field mirrors MT548 subsequence A2 field 25D Status Code. See https://www.iso20022.org/15022/uhb/mt548-10-field-25d.htm for MT548 code values."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "SettlementStatusReport(35=EE) is a response to the SettlementStatusRequest(35=EC) to provide settlement status for the requested trade. It may also be sent unsolicited without an explicit request message by the party able to provide the settlement status for the trade identified in the report message."
    },
    "EF": {
        "name": "SettlementStatusReportAck",
        "abbrName": "SettlStatRptAck",
        "addedEP": "281",
        "added": "FIX.Latest",
        "category": {
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "281",
            "FIXMLFileName": "settlstatmgmt",
            "added": "FIX.Latest",
            "name": "SettlementStatusManagement",
            "description": "Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process."
        },
        "msgType": "EF",
        "id": "168",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "2967",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SettlStatusReportID",
                    "abbrName": "RptID",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "id": "2967",
                    "description": "Unique identifier of the SettlementStatusReport(35=EE)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "281",
                "id": "2973",
                "presence": "required",
                "data": {
                    "type": "SettlStatusReportStatusCodeSet",
                    "name": "SettlStatusReportStatus",
                    "abbrName": "Stat",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "id": "2973",
                    "description": "Status of the report being responded to."
                }
            }
        ],
        "section": {
            "displayOrder": "3",
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "SettlementStatusReportAck(35=EF) is used to respond to the SettlementStatusReport(35=EE) to acknowledge or reject the report."
    },
    "EG": {
        "name": "SecurityRiskMetricsReport",
        "abbrName": "SecRiskMtrcsRpt",
        "addedEP": "288",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "FIXMLFileName": "securitiesreference",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "msgType": "EG",
        "id": "169",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "288",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "288",
                "id": "2988",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "SecurityRiskMetricsReportID",
                    "abbrName": "RptID",
                    "addedEP": "288",
                    "added": "FIX.Latest",
                    "id": "2988",
                    "description": "Unique identifier for the SecurityRiskMetricsReport(35=EG) message."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "288",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "SecurityRiskMetricsReport(35=EG) is used for publishing the risk metrics, valuation metrics or analytics of one or more securities, or for an option series."
    },
    "EH": {
        "name": "AlgoCertificateRequest",
        "abbrName": "AlgoCertReq",
        "updated": "FIX.Latest",
        "addedEP": "292",
        "added": "FIX.Latest",
        "updatedEP": "295",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EH",
        "id": "170",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3014",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AlgoCertificateRequestID",
                    "abbrName": "CertReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3014",
                    "description": "Unique identifier of the AlgoCertificateRequest(35=EH)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3016",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateRequestTransTypeCodeSet",
                    "name": "AlgoCertificateRequestTransType",
                    "abbrName": "TxnTyp",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3016",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "295",
                "id": "3077",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateRequestTypeCodeSet",
                    "name": "AlgoCertificateRequestType",
                    "abbrName": "ReqTyp",
                    "addedEP": "295",
                    "added": "FIX.Latest",
                    "id": "3077",
                    "description": "Specifies the type of business event related to an algo certification request."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "AlgoCertificateRequest(35=EH) is used to request algo testing certificate information for one or more algorithms.\n\nThis message may be used by venues to request algo test certificates from their participants using participant and algo identifiers as the request key. Absence of an identifier for an algorithm represents a request to obtain all active certificates for all algorithms from the participant.\n\nThis message may also be used by clients of algo trading firms to request the certified algos they are eligible to use."
    },
    "EI": {
        "name": "AlgoCertificateRequestAck",
        "abbrName": "AlgoCertReqAck",
        "addedEP": "292",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EI",
        "id": "171",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3014",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AlgoCertificateRequestID",
                    "abbrName": "CertReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3014",
                    "description": "Unique identifier of the AlgoCertificateRequest(35=EH)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3017",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateRequestStatusCodeSet",
                    "name": "AlgoCertificateRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3017",
                    "description": "Status of the AlgoCertificateRequest(35=EH) message being responded to."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "295",
                "id": "3077",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateRequestTypeCodeSet",
                    "name": "AlgoCertificateRequestType",
                    "abbrName": "ReqTyp",
                    "addedEP": "295",
                    "added": "FIX.Latest",
                    "id": "3077",
                    "description": "Specifies the type of business event related to an algo certification request."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "AlgoCertificateRequestAck(35=EI) is used to respond to the AlgoCertificateRequest(35=EH) to acknowledge the request and provide status for the request message.\n\nThis message is not used for communicating test certificates of algorithms (see AlgoCertificateReport(35=EJ)); simply a status of the request message itself."
    },
    "EJ": {
        "name": "AlgoCertificateReport",
        "abbrName": "AlgoCertRpt",
        "addedEP": "292",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EJ",
        "id": "172",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "779",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "LastUpdateTime",
                    "abbrName": "LastUpdateTm",
                    "added": "FIX.4.4",
                    "id": "779",
                    "description": "Timestamp of last update to data item (or creation if no updates made since creation)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "Parties",
                    "abbrName": "Pty",
                    "added": "FIX.4.3",
                    "category": "Common",
                    "id": "1012",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3012",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AlgoCertificateID",
                    "abbrName": "CertID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3012",
                    "description": "Unique identifier for a certificate issued by an algorithmic trading firm."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3018",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AlgoCertificateReportID",
                    "abbrName": "CertRptID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3018",
                    "description": "Unique identifier of the AlgoCertificateReport(35=EJ)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3020",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateReportTransTypeCodeSet",
                    "name": "AlgoCertificateReportTransType",
                    "abbrName": "TxnTyp",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3020",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3022",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateStatusCodeSet",
                    "name": "AlgoCertificateStatus",
                    "abbrName": "CertStat",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3022",
                    "description": "Status of the certification as provided by the regulatory authority."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "AlgoCertificateReport(35=EJ) is a response to the AlgoCertificateRequest(35=EH) to certify an algo. It may also be sent unsolicited without an explicit request message by the party able to provide certificate information for the algo identified in the report message.\n\nAlgoCertificateReport(35=EJ) is for a single algorithm. A new certificate is created by the trading firm in a draft status and requires approval from a natural person who is authorized to approve certification. The final state is reached when the certificate has been successfully submitted to the venue. Timestamps may be associated with the state changes, specifically date and time of the latest change, the approval and when the certificate is to become effective."
    },
    "EK": {
        "name": "AlgoCertificateReportAck",
        "abbrName": "AlgoCertRptAck",
        "addedEP": "292",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EK",
        "id": "173",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3018",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "AlgoCertificateReportID",
                    "abbrName": "CertRptID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3018",
                    "description": "Unique identifier of the AlgoCertificateReport(35=EJ)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3021",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateReportStatusCodeSet",
                    "name": "AlgoCertificateReportStatus",
                    "abbrName": "RptStat",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3021",
                    "description": "Status of the report being responded to."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "AlgoCertificateReportAck(35=EK) is used to respond to the AlgoCertificateReport(35=EJ) to acknowledge or reject the report message.\n\nAcknowledgement messages can also be used in response to unsolicited reports."
    },
    "EL": {
        "name": "TestSuiteDefinitionRequest",
        "abbrName": "TstSteDefReq",
        "addedEP": "292",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EL",
        "id": "174",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "2277",
                "presence": "required",
                "data": {
                    "type": "group",
                    "name": "TestScenarioGrp",
                    "abbrName": "TstScnro",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "category": "Testing",
                    "id": "2277",
                    "numInGroup": { "id": "3028", "added": "FIX.Latest", "addedEP": "292" },
                    "description": "TestScenarioGrp provides details for a collection of test cases/scenarios that makes up a test suite.\n\nAn instance of the repeating group represents a single test case/scenario. Each test case/scenario includes one or more test steps. The test case/scenario has a single status made up of one or more test measure or criteria results across the test steps of the given test case/scenario. The individual test scenario status values contribute to the success or failure status of the test suite, subject to bilateral agreement."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3062",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestSuiteRequestID",
                    "abbrName": "TstSteReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3062",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3064",
                "presence": "required",
                "data": {
                    "type": "TestSuiteRequestTransTypeCodeSet",
                    "name": "TestSuiteRequestTransType",
                    "abbrName": "TxnTyp",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3064",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestSuiteDefinitionRequest(35=EL) is used to convey to the test system the suite of test scenarios to perform.\n\nThis message stages on the test system the details of a test suite to run to test the algo. The test suite contains one or more test scenarios (i.e. test cases) along with the details for each test scenario."
    },
    "EM": {
        "name": "TestSuiteDefinitionRequestAck",
        "abbrName": "TstSteDefReqAck",
        "addedEP": "292",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EM",
        "id": "175",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3062",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestSuiteRequestID",
                    "abbrName": "TstSteReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3062",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3065",
                "presence": "required",
                "data": {
                    "type": "TestSuiteRequestStatusCodeSet",
                    "name": "TestSuiteRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3065",
                    "description": "Status of the TestSuiteDefinitionRequest(35=EL) message being responded to."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestSuiteDefinitionRequestAck(35=EM) is used to respond to the TestSuiteDefinitionRequest(35= EL) to acknowledge the request and provide status for the request message."
    },
    "EN": {
        "name": "TestActionRequest",
        "abbrName": "TstActnReq",
        "addedEP": "292",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EN",
        "id": "176",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "60",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "name": "TransactTime",
                    "abbrName": "TxnTm",
                    "updated": "FIX.5.0SP1",
                    "added": "FIX.2.7",
                    "updatedEP": "94",
                    "id": "60",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3062",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestSuiteRequestID",
                    "abbrName": "TstSteReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3062",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3066",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestActionRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3066",
                    "description": "Unique identifier of the TestActionRequest(35=EN)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3067",
                "presence": "required",
                "data": {
                    "type": "TestActionTypeCodeSet",
                    "name": "TestActionType",
                    "abbrName": "ActnTyp",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3067",
                    "description": "Specifies the type of action to take or that was taken for a given test suite."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestActionRequest(35=EN) is used to manage test executions or request for testing activity state of the identified test suite.\n\nThis message is used to trigger the test system to start/stop the test suite staged on the test system via the TestSuiteDefinitionRequest(35=EL)."
    },
    "EO": {
        "name": "TestActionRequestAck",
        "abbrName": "TstActnReqAck",
        "addedEP": "292",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EO",
        "id": "177",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3062",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestSuiteRequestID",
                    "abbrName": "TstSteReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3062",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3066",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestActionRequestID",
                    "abbrName": "ReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3066",
                    "description": "Unique identifier of the TestActionRequest(35=EN)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3068",
                "presence": "required",
                "data": {
                    "type": "TestActionRequestStatusCodeSet",
                    "name": "TestActionRequestStatus",
                    "abbrName": "ReqStat",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3068",
                    "description": "Status of the TestActionRequest(35=EN) message being responded to."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3069",
                "presence": "required",
                "data": {
                    "type": "TestSuiteActivityStateCodeSet",
                    "name": "TestSuiteActivityState",
                    "abbrName": "TstSteActvtySt",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3069",
                    "description": "Specifies the activity state the test suite is in."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestActionRequestAck(35=EO) is used to respond to the TestActionRequest(35=EN) to acknowledge the request and provide status for the request message."
    },
    "EP": {
        "name": "TestActionReport",
        "abbrName": "TstActnRpt",
        "addedEP": "292",
        "added": "FIX.Latest",
        "category": {
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "FIXMLFileName": "testing",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "msgType": "EP",
        "id": "178",
        "structure": [
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1024",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardHeader",
                    "abbrName": "Hdr",
                    "updated": "FIX.Latest",
                    "added": "FIX.4.0",
                    "updatedEP": "271",
                    "category": "Session",
                    "id": "1024",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "8",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "9",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "35",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "49",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "56",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "34",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "added": "FIX.4.0",
                            "id": "52",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3062",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestSuiteRequestID",
                    "abbrName": "TstSteReqID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3062",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "3071",
                "presence": "required",
                "data": {
                    "type": "String",
                    "name": "TestActionReportID",
                    "abbrName": "RptID",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "id": "3071",
                    "description": "Identifier of the test action report."
                }
            },
            {
                "added": "FIX.Latest",
                "addedEP": "292",
                "id": "1025",
                "presence": "required",
                "data": {
                    "type": "component",
                    "name": "StandardTrailer",
                    "abbrName": "Trlr",
                    "added": "FIX.4.0",
                    "category": "Session",
                    "id": "1025",
                    "fieldRef": [
                        {
                            "added": "FIX.4.0",
                            "id": "10",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PreTrade",
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestActionReport(35=EP) is used to report the testing results of the identified test suite that has been executed with TestActionRequest(35=EN). In the context of algorithmic trading, the results may be used to create a certificate for the algorithm upon meeting the success criteria.\n\nTestActionReport(35=EP) may be sent in an unsolicited manner when the execution of a test suite successfully completes or abnormally terminates."
    }
}
